import { Fragment as e, jsx as t, jsxs as n } from "preact/jsx-runtime";
import { UserManager as r, WebStorageStateStore as i } from "oidc-client-ts";
import { computed as a, signal as o } from "@preact/signals";
import { useEffect as s, useMemo as c, useRef as l, useState as u } from "preact/hooks";
import { BarController as d, BarElement as f, Chart as p, Filler as m, LineController as h, LineElement as g, LinearScale as _, PointElement as v, Tooltip as ee } from "chart.js";
import { Link as y, Route as b, Switch as x, useLocation as S } from "wouter-preact";
import { render as C } from "preact";
//#region src/version.ts
var w = "0.5.0";
//#endregion
//#region src/ShellPlaceholder.tsx
function te({ app: e }) {
	return /* @__PURE__ */ t("div", {
		class: "gs-placeholder",
		"data-testid": "shell-placeholder",
		children: /* @__PURE__ */ n("p", { children: [
			e,
			" on @gimasi/giothub-shell ",
			w
		] })
	});
}
//#endregion
//#region src/config.ts
var T = null;
async function E() {
	let e = await fetch("/config.json", { cache: "no-store" });
	if (!e.ok) throw Error(`config.json: ${e.status}`);
	return T = await e.json(), T;
}
function ne(e) {
	T = e;
}
function D() {
	if (!T) throw Error("config not loaded");
	return T;
}
//#endregion
//#region src/auth/oidc.ts
var O = null;
function k() {
	if (O) return O;
	let e = D(), t = e.oidc.scope || `openid profile email offline_access urn:zitadel:iam:user:resourceowner urn:zitadel:iam:org:project:id:${e.oidc.audience}:aud`;
	return O = new r({
		authority: e.oidc.issuer,
		client_id: e.oidc.client_id,
		redirect_uri: `${location.origin}/auth/callback`,
		post_logout_redirect_uri: `${location.origin}/`,
		response_type: "code",
		scope: t,
		automaticSilentRenew: !0,
		userStore: new i({ store: window.sessionStorage })
	}), O;
}
var A = () => !!D().dev_api_key;
async function re() {
	let e = D().dev_api_key;
	if (e) return e;
	let t = await k().getUser();
	return t && !t.expired ? t.access_token : "";
}
async function ie() {
	if (A()) return null;
	let e = await k().getUser();
	return e && !e.expired ? e : null;
}
function ae(e = location.pathname + location.search) {
	return k().signinRedirect({ state: { returnTo: e } });
}
async function oe() {
	let e = (await k().signinRedirectCallback()).state;
	return e?.returnTo && e.returnTo.startsWith("/") ? e.returnTo : "/";
}
async function se() {
	A() ? location.href = "/" : await k().signoutRedirect();
}
//#endregion
//#region src/api/deviceId.ts
var ce = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;
function le(e) {
	return typeof e == "string" && ce.test(e);
}
function ue(e) {
	return e?.name || e?.device_serial || e?.device_id || "";
}
function de(e) {
	return e?.device_serial || e?.device_id || "";
}
var fe = /* @__PURE__ */ new Map();
function pe(e, t) {
	let n = (e || "").trim();
	if (!n) return Promise.resolve(null);
	if (le(n)) return Promise.resolve(n.toLowerCase());
	let r = n.toLowerCase(), i = fe.get(r);
	return i || (i = t(r).catch(() => null), fe.set(r, i), i.then((e) => {
		e || fe.delete(r);
	})), i;
}
function me(e, t) {
	return e < t ? -1 : +(e > t);
}
//#endregion
//#region src/api/client.ts
var j = class extends Error {
	status;
	code;
	field_errors;
	constructor(e) {
		super(e.message), this.status = e.status, this.code = e.code, this.field_errors = e.field_errors;
	}
};
function he(e) {
	if (!e) return "";
	let t = new URLSearchParams();
	for (let [n, r] of Object.entries(e)) r != null && r !== "" && t.set(n, String(r));
	let n = t.toString();
	return n ? "?" + n : "";
}
var ge = (e) => e ? { "Idempotency-Key": e } : void 0;
async function M(e, t, n, r, i) {
	let a = await re(), o = {
		Accept: "application/json",
		...i
	};
	a && (o.Authorization = "Bearer " + a), n !== void 0 && (o["Content-Type"] = "application/json");
	let s = await fetch(D().api_base + t + he(r), {
		method: e,
		headers: o,
		body: n === void 0 ? void 0 : JSON.stringify(n)
	});
	if (s.status === 401 && !A()) throw await ae(), new j({
		status: 401,
		code: "unauthorized",
		message: "signing in again"
	});
	if (s.status === 204) return;
	let c = await s.text(), l = null;
	try {
		l = c ? JSON.parse(c) : null;
	} catch {}
	if (!s.ok) {
		let e = l || {};
		throw e.code === "ai_disabled" && window.dispatchEvent(new Event("glm:ai-disabled")), new j({
			status: s.status,
			code: e.code || "http_" + s.status,
			message: e.message || c || s.statusText,
			field_errors: e.field_errors
		});
	}
	return l;
}
var N = (e, t) => M("GET", e, void 0, t), P = encodeURIComponent, F = {
	whoami: () => N("/whoami"),
	me: () => N("/me"),
	permissions: () => N("/permissions"),
	fleetSummary: () => N("/fleet/summary"),
	devices: (e) => N("/devices", e),
	fleetDevices: (e) => N("/fleet/devices", { query: JSON.stringify(e) }),
	device: (e) => N(`/devices/${P(e)}`),
	deviceKeys: (e, t) => N(`/devices/${P(e)}/keys`, { lang: t }),
	series: (e, t) => N(`/devices/${P(e)}/series`, t),
	deviceEvents: (e, t) => N(`/devices/${P(e)}/events`, t),
	deviceEvent: (e, t, n) => N(`/devices/${P(e)}/events/${P(t)}`, { at: n }),
	events: (e) => N("/events", e),
	alarms: (e) => N("/alarms", e),
	types: (e) => N("/types", { lang: e }),
	type: (e, t) => N(`/types/${P(e)}`, { version: t }),
	configHistory: (e, t = 50) => N(`/devices/${P(e)}/config/history`, { limit: t }),
	configVersion: (e, t, n) => N(`/devices/${P(e)}/config/versions/${t}`, { against: n }),
	patchConfig: (e, t, n) => M("PATCH", `/devices/${P(e)}/config`, {
		base_version: t,
		changes: n
	}),
	dropOverride: (e, t) => M("DELETE", `/devices/${P(e)}/config/overrides/${P(t)}`),
	command: (e, t, n) => M("POST", `/devices/${P(e)}/commands`, {
		type: t,
		...n
	}),
	actions: (e) => N("/actions", e),
	cancelAction: (e) => M("DELETE", `/actions/${e}`),
	propertyDefs: () => N("/property-defs"),
	putPropertyDef: (e, t) => M("PUT", `/property-defs/${P(e)}`, t),
	deletePropertyDef: (e) => M("DELETE", `/property-defs/${P(e)}`),
	labelValues: (e) => N(`/labels/${P(e)}/values`),
	putLabelValue: (e, t, n) => M("PUT", `/labels/${P(e)}/values/${P(t)}`, n),
	hierarchies: () => N("/hierarchies"),
	putHierarchy: (e, t) => M("PUT", `/hierarchies/${P(e)}`, t),
	deleteHierarchy: (e) => M("DELETE", `/hierarchies/${P(e)}`),
	tree: (e) => N("/tree", e),
	patchDevice: (e, t) => M("PATCH", `/devices/${P(e)}`, t),
	addDevice: (e) => M("POST", "/devices", e),
	deviceBySerial: (e) => N("/devices", { serial: e }).then((e) => e.items?.[0] || null),
	resolveDeviceID: (e) => pe(e, (e) => F.deviceBySerial(e).then((e) => e && le(e.device_id) ? e.device_id : null)),
	models: (e) => N("/models", { type_id: e }),
	model: (e) => N(`/models/${e}`),
	createModel: (e) => M("POST", "/models", e),
	patchModel: (e, t) => M("PATCH", `/models/${e}`, t),
	deleteModel: (e) => M("DELETE", `/models/${e}`),
	storeTypes: (e) => N("/store/types", { q: e }),
	storeTicket: () => M("POST", "/store/ticket"),
	installType: (e, t) => M("POST", "/types/install", {
		id: e,
		version: t
	}),
	typeSources: () => N("/type-sources"),
	addTypeSource: (e) => M("POST", "/type-sources", e),
	patchTypeSource: (e, t) => M("PATCH", `/type-sources/${e}`, t),
	sourceKey: () => M("POST", "/type-sources/ssh-key"),
	deleteTypeSource: (e) => M("DELETE", `/type-sources/${e}`),
	typeSourceTags: (e) => N(`/type-sources/${e}/tags`),
	typeSourceTag: (e, t) => N(`/type-sources/${e}/tags/${t.split("/").map(P).join("/")}`),
	installFromSource: (e, t, n) => M("POST", `/type-sources/${e}/install`, {
		tag: t,
		path: n
	}),
	keyRoles: () => N("/key-roles"),
	deviceFiles: (e) => N(`/devices/${P(e)}/files`),
	startUpload: (e, t) => M("POST", `/devices/${P(e)}/files`, t),
	uploadViaAPI: async (e, t, n) => {
		let r = await re(), i = await fetch(D().api_base + `/devices/${P(e)}/files/content?token=${encodeURIComponent(t)}`, {
			method: "PUT",
			headers: {
				...r ? { Authorization: "Bearer " + r } : {},
				"Content-Type": "application/octet-stream"
			},
			body: n
		});
		if (!i.ok) {
			let e = i.statusText;
			try {
				e = (await i.json()).message || e;
			} catch {}
			throw new j({
				status: i.status,
				code: "http_" + i.status,
				message: e
			});
		}
	},
	completeUpload: (e, t) => M("POST", `/devices/${P(e)}/files/complete`, { token: t }),
	deleteFile: (e, t) => M("DELETE", `/devices/${P(e)}/files/${P(t)}`),
	deviceChanges: (e) => N(`/devices/${P(e)}/changes`),
	deviceGroups: (e) => N(`/devices/${P(e)}/groups`),
	users: () => N("/users"),
	inviteUser: (e) => M("POST", "/users", e),
	patchUser: (e, t) => M("PATCH", `/users/${P(e)}`, t),
	roles: () => N("/roles"),
	putRole: (e, t) => M("PUT", `/roles/${P(e)}`, t),
	deleteRole: (e) => M("DELETE", `/roles/${P(e)}`),
	roleAssignments: () => N("/role-assignments"),
	addRoleAssignment: (e) => M("POST", "/role-assignments", e),
	deleteRoleAssignment: (e) => M("DELETE", `/role-assignments/${e}`),
	groups: () => N("/groups"),
	group: (e) => N(`/groups/${e}`),
	createGroup: (e) => M("POST", "/groups", e),
	patchGroup: (e, t) => M("PATCH", `/groups/${e}`, t),
	deleteGroup: (e) => M("DELETE", `/groups/${e}`),
	groupMembers: (e, t = 1) => N(`/groups/${e}/members`, { page: t }),
	addGroupMembers: (e, t) => M("POST", `/groups/${e}/members`, { device_ids: t }),
	removeGroupMember: (e, t) => M("DELETE", `/groups/${e}/members/${P(t)}`),
	rules: () => N("/rules"),
	rule: (e) => N(`/rules/${e}`),
	createRule: (e) => M("POST", "/rules", e),
	patchRule: (e, t) => M("PATCH", `/rules/${e}`, t),
	deleteRule: (e) => M("DELETE", `/rules/${e}`),
	interactions: () => N("/interactions"),
	interaction: (e) => N(`/interactions/${e}`),
	createInteraction: (e) => M("POST", "/interactions", { name: e }),
	renameInteraction: (e, t) => M("PATCH", `/interactions/${e}`, { name: t }),
	deleteInteraction: (e) => M("DELETE", `/interactions/${e}`),
	ixMessage: (e, t, n, r) => M("POST", `/interactions/${e}/messages`, {
		message: t,
		lang: n,
		tz: r
	}),
	deleteIxAsset: (e, t) => M("DELETE", `/interactions/${e}/assets/${t}`),
	ixAssetBlob: async (e, t, n) => {
		let r = await re(), i = await fetch(D().api_base + `/interactions/${e}/assets/${t}` + (n ? `/preview/${n}` : ""), { headers: r ? { Authorization: "Bearer " + r } : {} });
		if (!i.ok) throw new j({
			status: i.status,
			code: "http_" + i.status,
			message: await i.text()
		});
		return i.blob();
	},
	aiUsage: () => N("/ai/usage"),
	ruleAI: (e) => M("POST", "/rule-ai", e),
	ruleAIGet: (e) => N(`/rule-ai/${e}`),
	bulk: (e) => N(`/bulk/${e}`),
	bulkCreate: (e) => M("POST", "/bulk", e),
	geoPlace: (e) => N("/geo/place", { q: e }),
	bulkAct: (e, t) => M("POST", `/bulk/${e}/${t}`),
	dashboards: () => N("/dashboards"),
	dashboard: (e) => N(`/dashboards/${e}`),
	homeDashboard: () => N("/dashboards/home"),
	createDashboard: (e) => M("POST", "/dashboards", { name: e }),
	patchDashboard: (e, t) => M("PATCH", `/dashboards/${e}`, t),
	deleteDashboard: (e) => M("DELETE", `/dashboards/${e}`),
	putDashSpec: (e, t, n) => M("PUT", `/dashboards/${e}/spec`, {
		spec: t,
		label: n
	}),
	undoDashboard: (e, t = !1) => M("POST", `/dashboards/${e}/${t ? "redo" : "undo"}`),
	publishDashboard: (e) => M("POST", `/dashboards/${e}/publish`),
	duplicateDashboard: (e) => M("POST", `/dashboards/${e}/duplicate`),
	dashboardData: (e, t) => N(`/dashboards/${e}/data`, {
		page: t.page,
		w: t.w,
		f: t.f,
		draft: t.draft ? 1 : void 0,
		device: t.device || void 0
	}),
	dashChat: (e, t) => M("POST", `/dashboards/${e}/chat`, t),
	putSettings: (e) => M("PUT", "/me/settings", e),
	tenantSettings: () => N("/settings/tenant"),
	putTenantSettings: (e) => M("PUT", "/settings/tenant", e),
	apiKeys: (e = !1) => N("/api-keys", { revoked: e ? 1 : void 0 }),
	createApiKey: (e, t) => M("POST", "/api-keys", e, void 0, ge(t)),
	rotateApiKey: (e, t) => M("POST", `/api-keys/${P(e)}/rotate`, void 0, void 0, ge(t)),
	revokeApiKey: (e) => M("DELETE", `/api-keys/${P(e)}`),
	apiCalls: (e) => N("/api-calls", e),
	apiCall: (e) => N(`/api-calls/${P(e)}`),
	apiCallTotals: (e) => N("/api-calls/totals", e),
	tasks: () => N("/tasks"),
	task: (e) => N(`/tasks/${e}`),
	createTask: (e) => M("POST", "/tasks", e ? { name: e } : {}),
	patchTask: (e, t) => M("PATCH", `/tasks/${e}`, t),
	deleteTask: (e) => M("DELETE", `/tasks/${e}`),
	taskChat: (e, t, n, r) => M("POST", `/tasks/${e}/chat`, {
		message: t,
		lang: n,
		tz: r
	}),
	finalizeTask: (e, t) => M("POST", `/tasks/${e}/finalize`, { activate: t }),
	runTask: (e) => M("POST", `/tasks/${e}/run`),
	taskRuns: (e) => N(`/tasks/${e}/runs`),
	taskRun: (e) => N(`/task-runs/${e}`),
	pinRun: (e, t) => M(t ? "PUT" : "DELETE", `/task-runs/${e}/pin`),
	taskFile: async (e, t) => {
		let n = await re(), r = await fetch(D().api_base + `/task-runs/${e}/files/${t}`, { headers: n ? { Authorization: "Bearer " + n } : {} });
		if (!r.ok) throw new j({
			status: r.status,
			code: "http_" + r.status,
			message: await r.text()
		});
		return r.blob();
	},
	deviceRules: (e) => N(`/devices/${P(e)}/rules`),
	setDeviceRules: (e, t) => M("PUT", `/devices/${P(e)}/rules`, { rule_ids: t }),
	groupRules: (e) => N(`/groups/${e}/rules`),
	setGroupRules: (e, t) => M("PUT", `/groups/${e}/rules`, { rule_ids: t }),
	simulateDeviceRules: (e, t) => M("POST", `/devices/${P(e)}/rules/simulate`, t ? { rule_ids: t } : {}),
	ruleEvents: (e) => N(`/rules/${e}/events`),
	simulateRule: (e, t) => M("POST", "/rules/simulate", {
		rule: e,
		...t
	}),
	simulateGroup: (e, t) => M("POST", "/groups/simulate", {
		group: e,
		...t
	}),
	typeDetail: (e, t) => _e(e, void 0, t)
};
async function _e(e, t, n) {
	let [r, i] = await Promise.all([N(`/types/${P(e)}`, {
		version: t,
		lang: n
	}), N(`/types/${P(e)}/widgets`, {
		version: t,
		lang: n
	}).catch(() => null)]);
	return i && (r.keys = (r.keys || []).map((e) => i.keys[e.key] ? {
		...e,
		...i.keys[e.key],
		widget: i.keys[e.key].widget || e.widget
	} : e)), r;
}
var ve = {
	alarms: (e) => N("/alarms", e),
	ackAlarm: (e, t) => M("POST", `/alarms/${e}/acknowledge`, { note: t }),
	typeDetail: (e, t, n) => _e(e, t, n),
	audit: (e) => N("/audit", e)
}, ye = {
	loading: "Lade…",
	error_title: "Etwas ist schiefgelaufen",
	retry: "Erneut versuchen",
	close: "Schließen",
	pager: "Seiten",
	pager_range: "%1$s–%2$s von %3$s",
	pager_prev: "Vorherige Seite",
	pager_next: "Nächste Seite",
	pager_size: "Zeilen pro Seite",
	pager_per_page: "%1$s pro Seite",
	pager_page: "Seite %1$s",
	pager_newer: "Neuere",
	pager_older: "Ältere",
	pager_newest: "Neueste",
	days_unit: "Tage",
	in_future: "in %1$s",
	just_now: "gerade eben",
	ago: "vor %1$s",
	all_devices: "alle Geräte",
	sign_in: "Anmelden",
	sign_out: "Abmelden",
	signing_in: "Anmeldung…",
	signin_title: "Bei %1$s anmelden",
	signin_text: "Sie melden sich mit Ihrem Firmenkonto an.",
	dev_mode: "Entwicklung: API-Schlüssel statt Anmeldung",
	no_role_title: "Noch kein Zugriff",
	no_role_text: "Ihr Konto ist bekannt, aber ein Administrator hat Ihnen noch keine Rolle gegeben.",
	config_error: "config.json kann nicht geladen werden (%1$s)",
	language: "Sprache",
	scheme: "Farbschema",
	scheme_auto: "Auto",
	scheme_light: "Hell",
	scheme_dark: "Dunkel",
	debug_title: "Sitzung",
	debug_text: "Was die Tenant-API über diese Sitzung meldet (/whoami und /me).",
	menu_main: "Hauptmenü",
	not_found_title: "Seite nicht gefunden",
	not_found_text: "Diese Adresse gibt es in der Anwendung nicht.",
	not_allowed_title: "Kein Zugriff auf diese Seite",
	not_allowed_text: "Ihre Rolle umfasst diese Seite nicht. Ein Administrator kann das ändern.",
	skip_to_content: "Zum Inhalt springen",
	menu_open: "Menü öffnen",
	menu_close: "Menü schließen",
	search: "Suchen",
	search_pages: "Zu einer Seite…",
	search_none: "Keine passende Seite",
	account: "Konto",
	alarms_open: "%1$s offene Alarme",
	devices: "Geräte",
	devices_n: {
		one: "%1$s Gerät",
		other: "%1$s Geräte"
	},
	search_devices: "Name oder Seriennummer suchen",
	label_filter: "Label",
	label_value: "Labelwert",
	label_any: "Jeder Wert",
	no_device_match: "Kein passendes Gerät",
	no_devices_title: "Noch keine Geräte",
	no_devices_text: "Geräte erscheinen hier, sobald sie eingebunden sind.",
	col_contact: "Kontakt",
	col_serial: "Geräte-Seriennummer",
	col_name: "Name",
	col_type: "Typ",
	col_battery: "Batterie",
	col_last_seen: "Zuletzt gesehen",
	contact_good: "Kontakt innerhalb von 24 h",
	contact_neutral: "Letzter Kontakt vor 1 bis 7 Tagen",
	contact_warn: "Seit mehr als 7 Tagen kein Kontakt",
	battery_low: "Schwach",
	battery_ok: "OK",
	never: "nie",
	settings: "Einstellungen",
	api_access: "API",
	api_keys: "Schlüssel",
	api_calls: "Aufrufe",
	api_docs: "API-Dokumentation",
	api_key_new: "Neuer Schlüssel",
	api_cannot_create: "Sie können in Ihren Konten keine Berechtigung vergeben",
	api_expiry_warning: {
		one: "%1$s Schlüssel ist abgelaufen oder läuft in 30 Tagen ab - erneuern Sie ihn, damit Integrationen weiter funktionieren.",
		other: "%1$s Schlüssel sind abgelaufen oder laufen in 30 Tagen ab - erneuern Sie sie, damit Integrationen weiter funktionieren."
	},
	api_show_revoked: "Widerrufene Schlüssel anzeigen",
	api_no_keys: "Noch keine API-Schlüssel",
	api_no_keys_text: "Mit einem Schlüssel ruft Ihr eigenes Backend die API auf.",
	api_scopes: "Berechtigungen",
	api_account: "Konto",
	api_account_root: "Ganzer Mandant",
	api_account_hint: "Der Schlüssel sieht dieses Konto und die Konten darunter.",
	api_rate: "Ratenlimit",
	api_rate_min: "%1$s/min",
	api_burst_value: "Spitze %1$s",
	api_quota_value: "%1$s pro Tag",
	api_created: "Erstellt",
	api_last_used: "Zuletzt verwendet",
	api_expires: "Läuft ab",
	api_actions: "Aktionen",
	api_by_support: "Gimasi-Support",
	api_by_security: "Gimasi-Sicherheit",
	api_state_active: "Aktiv",
	api_state_revoked: "Widerrufen",
	api_state_expired: "Abgelaufen",
	api_state_expiring: {
		one: "Läuft in %1$s Tag ab",
		other: "Läuft in %1$s Tagen ab"
	},
	api_state_rotating: {
		one: "Ersetzt, gilt noch %1$s Tag",
		other: "Ersetzt, gilt noch %1$s Tage"
	},
	api_scope_read: "Lesen",
	api_scope_read_text: "jedes GET: Geräte, Daten, Alarme",
	api_scope_config: "Konfiguration",
	api_scope_config_text: "Gerätekonfigurationen ändern",
	api_scope_commands: "Befehle",
	api_scope_commands_text: "Befehle an Geräte senden",
	api_scope_ui: "Website-Backend",
	api_scope_ui_text: "handelt für seine angemeldeten Benutzer (X-Glm-User)",
	api_rotate: "Erneuern",
	api_revoke: "Widerrufen",
	api_rotate_title: "%1$s erneuern",
	api_revoke_title: "%1$s widerrufen",
	api_rotate_text: "Ein neues Geheimnis wird ausgegeben. Das alte gilt noch 7 Tage, damit Sie Ihr Backend umstellen können.",
	api_revoke_text: "Der Schlüssel funktioniert innerhalb von 30 Sekunden nicht mehr. Dies kann nicht rückgängig gemacht werden.",
	api_secret_title: "Ihr neuer Schlüssel",
	api_secret_once: "Kopieren Sie das Geheimnis von %1$s jetzt und bewahren Sie es sicher auf: Es wird nur dieses eine Mal angezeigt.",
	api_secret: "Geheimnis",
	api_copy: "Kopieren",
	api_copied: "Kopiert",
	api_secret_done: "Ich habe es gespeichert",
	api_err_name: "Geben Sie dem Schlüssel einen Namen",
	api_err_scopes: "Wählen Sie mindestens eine Berechtigung",
	api_err_range: "Zwischen %1$s und %2$s",
	api_err_form: "Bitte korrigieren Sie die markierten Felder",
	api_rate_per_min: "Anfragen pro Minute",
	api_rate_max: "Höchstens %1$s (Ihr Tarif)",
	api_burst: "Spitze",
	api_daily_quota: "Tageskontingent (optional)",
	api_quota_none: "Kein Kontingent",
	api_valid_days: "Gültig für (Tage)",
	api_valid_until: "Bis %1$s",
	api_create: "Schlüssel erstellen",
	api_range: "Zeitraum",
	api_range_1h: "Letzte Stunde",
	api_range_24h: "Letzte 24 Stunden",
	api_range_7d: "Letzte 7 Tage",
	api_range_30d: "Letzte 30 Tage",
	api_range_90d: "Letzte 90 Tage",
	api_key: "Schlüssel",
	api_all_keys: "Alle Schlüssel",
	api_status: "Status",
	api_all_statuses: "Jeder Status",
	api_status_2xx: "Erfolg (2xx)",
	api_status_4xx: "Abgelehnt (4xx)",
	api_status_429: "Limit erreicht (429)",
	api_status_5xx: "Serverfehler (5xx)",
	api_path: "Pfad",
	api_path_placeholder: "Pfad, z. B. /api/v1/devices",
	api_totals: "Aufrufe pro Schlüssel und Tag (UTC)",
	api_total: "Gesamt",
	api_errors: "Fehler",
	api_throttled: "Begrenzt",
	api_no_calls: "Keine Aufrufe in diesem Zeitraum",
	api_no_calls_text: "Aufgeführt werden nur Anfragen mit API-Schlüsseln, nicht die der Anwendungen.",
	api_time: "Zeit",
	api_request: "Anfrage",
	api_duration: "Dauer",
	api_bytes: "Größe",
	api_bytes_in: "Anfragegröße",
	api_bytes_out: "Antwortgröße",
	api_key_gone: "Schlüssel gelöscht",
	api_call_detail: "Aufruf",
	api_error_code: "Fehlercode",
	api_client_ip: "Client-IP",
	api_user_agent: "User-Agent",
	api_request_id: "Anfrage-ID"
}, be = {
	loading: "Loading…",
	error_title: "Something went wrong",
	retry: "Retry",
	close: "Close",
	pager: "Pages",
	pager_range: "%1$s–%2$s of %3$s",
	pager_prev: "Previous page",
	pager_next: "Next page",
	pager_size: "Rows per page",
	pager_per_page: "%1$s per page",
	pager_page: "Page %1$s",
	pager_newer: "Newer",
	pager_older: "Older",
	pager_newest: "Newest",
	days_unit: "days",
	in_future: "in %1$s",
	just_now: "just now",
	ago: "%1$s ago",
	all_devices: "all devices",
	sign_in: "Sign in",
	sign_out: "Sign out",
	signing_in: "Signing in…",
	signin_title: "Sign in to %1$s",
	signin_text: "You sign in with your company account.",
	dev_mode: "Development: API key instead of sign-in",
	no_role_title: "No access yet",
	no_role_text: "Your account is known, but an administrator has not given you a role yet.",
	config_error: "Cannot load config.json (%1$s)",
	language: "Language",
	scheme: "Colour scheme",
	scheme_auto: "Auto",
	scheme_light: "Light",
	scheme_dark: "Dark",
	debug_title: "Session",
	debug_text: "What the tenant API says about this session (/whoami and /me).",
	menu_main: "Main menu",
	not_found_title: "Page not found",
	not_found_text: "This address does not exist in the application.",
	not_allowed_title: "No access to this page",
	not_allowed_text: "Your role does not include this page. An administrator can change it.",
	skip_to_content: "Skip to content",
	menu_open: "Open menu",
	menu_close: "Close menu",
	search: "Search",
	search_pages: "Go to a page…",
	search_none: "No page matches",
	account: "Account",
	alarms_open: "%1$s open alarms",
	devices: "Devices",
	devices_n: {
		one: "%1$s device",
		other: "%1$s devices"
	},
	search_devices: "Search name or serial",
	label_filter: "Label",
	label_value: "Label value",
	label_any: "Any value",
	no_device_match: "No device matches",
	no_devices_title: "No devices yet",
	no_devices_text: "Devices appear here once they are onboarded.",
	col_contact: "Contact",
	col_serial: "Device serial",
	col_name: "Name",
	col_type: "Type",
	col_battery: "Battery",
	col_last_seen: "Last seen",
	contact_good: "In contact within 24 h",
	contact_neutral: "Last contact 1 to 7 days ago",
	contact_warn: "No contact for more than 7 days",
	battery_low: "Low",
	battery_ok: "OK",
	never: "never",
	settings: "Settings",
	api_access: "API",
	api_keys: "Keys",
	api_calls: "Calls",
	api_docs: "API documentation",
	api_key_new: "New key",
	api_cannot_create: "You cannot give any scope in your accounts",
	api_expiry_warning: {
		one: "%1$s key has expired or expires within 30 days - rotate it to keep integrations working.",
		other: "%1$s keys have expired or expire within 30 days - rotate them to keep integrations working."
	},
	api_show_revoked: "Show revoked keys",
	api_no_keys: "No API keys yet",
	api_no_keys_text: "A key lets your own backend call the API.",
	api_scopes: "Scopes",
	api_account: "Account",
	api_account_root: "Whole tenant",
	api_account_hint: "The key sees this account and the accounts below it.",
	api_rate: "Rate limit",
	api_rate_min: "%1$s/min",
	api_burst_value: "burst %1$s",
	api_quota_value: "%1$s per day",
	api_created: "Created",
	api_last_used: "Last used",
	api_expires: "Expires",
	api_actions: "Actions",
	api_by_support: "Gimasi support",
	api_by_security: "Gimasi security",
	api_state_active: "Active",
	api_state_revoked: "Revoked",
	api_state_expired: "Expired",
	api_state_expiring: {
		one: "Expires in %1$s day",
		other: "Expires in %1$s days"
	},
	api_state_rotating: {
		one: "Replaced, works %1$s more day",
		other: "Replaced, works %1$s more days"
	},
	api_scope_read: "Read",
	api_scope_read_text: "every GET: devices, data, alarms",
	api_scope_config: "Configuration",
	api_scope_config_text: "change device configurations",
	api_scope_commands: "Commands",
	api_scope_commands_text: "send commands to devices",
	api_scope_ui: "Website backend",
	api_scope_ui_text: "acts for its signed-in users (X-Glm-User)",
	api_rotate: "Rotate",
	api_revoke: "Revoke",
	api_rotate_title: "Rotate %1$s",
	api_revoke_title: "Revoke %1$s",
	api_rotate_text: "A new secret is issued. The old one keeps working for 7 days, so you can update your backend.",
	api_revoke_text: "The key stops working within 30 seconds. This cannot be undone.",
	api_secret_title: "Your new key",
	api_secret_once: "Copy the secret of %1$s now and store it safely: it is shown only this once.",
	api_secret: "Secret",
	api_copy: "Copy",
	api_copied: "Copied",
	api_secret_done: "I have stored it",
	api_err_name: "Give the key a name",
	api_err_scopes: "Choose at least one scope",
	api_err_range: "Between %1$s and %2$s",
	api_err_form: "Please correct the marked fields",
	api_rate_per_min: "Requests per minute",
	api_rate_max: "At most %1$s (your plan)",
	api_burst: "Burst",
	api_daily_quota: "Daily quota (optional)",
	api_quota_none: "No quota",
	api_valid_days: "Valid for (days)",
	api_valid_until: "Until %1$s",
	api_create: "Create key",
	api_range: "Time range",
	api_range_1h: "Last hour",
	api_range_24h: "Last 24 hours",
	api_range_7d: "Last 7 days",
	api_range_30d: "Last 30 days",
	api_range_90d: "Last 90 days",
	api_key: "Key",
	api_all_keys: "All keys",
	api_status: "Status",
	api_all_statuses: "Any status",
	api_status_2xx: "Success (2xx)",
	api_status_4xx: "Refused (4xx)",
	api_status_429: "Rate limited (429)",
	api_status_5xx: "Server error (5xx)",
	api_path: "Path",
	api_path_placeholder: "Path, e.g. /api/v1/devices",
	api_totals: "Calls per key and day (UTC)",
	api_total: "Total",
	api_errors: "Errors",
	api_throttled: "Limited",
	api_no_calls: "No calls in this period",
	api_no_calls_text: "Only requests made with API keys are listed, not those of the apps.",
	api_time: "Time",
	api_request: "Request",
	api_duration: "Duration",
	api_bytes: "Size",
	api_bytes_in: "Request size",
	api_bytes_out: "Response size",
	api_key_gone: "Key deleted",
	api_call_detail: "Call",
	api_error_code: "Error code",
	api_client_ip: "Client IP",
	api_user_agent: "User agent",
	api_request_id: "Request ID"
}, xe = {
	loading: "Chargement…",
	error_title: "Une erreur s'est produite",
	retry: "Réessayer",
	close: "Fermer",
	pager: "Pages",
	pager_range: "%1$s–%2$s sur %3$s",
	pager_prev: "Page précédente",
	pager_next: "Page suivante",
	pager_size: "Lignes par page",
	pager_per_page: "%1$s par page",
	pager_page: "Page %1$s",
	pager_newer: "Plus récents",
	pager_older: "Plus anciens",
	pager_newest: "Les plus récents",
	days_unit: "jours",
	in_future: "dans %1$s",
	just_now: "à l'instant",
	ago: "il y a %1$s",
	all_devices: "tous les appareils",
	sign_in: "Se connecter",
	sign_out: "Se déconnecter",
	signing_in: "Connexion…",
	signin_title: "Se connecter à %1$s",
	signin_text: "Vous vous connectez avec votre compte d'entreprise.",
	dev_mode: "Développement : clé API au lieu de la connexion",
	no_role_title: "Pas encore d'accès",
	no_role_text: "Votre compte est connu, mais un administrateur ne vous a pas encore attribué de rôle.",
	config_error: "Impossible de charger config.json (%1$s)",
	language: "Langue",
	scheme: "Thème de couleurs",
	scheme_auto: "Auto",
	scheme_light: "Clair",
	scheme_dark: "Sombre",
	debug_title: "Session",
	debug_text: "Ce que la tenant API dit de cette session (/whoami et /me).",
	menu_main: "Menu principal",
	not_found_title: "Page introuvable",
	not_found_text: "Cette adresse n'existe pas dans l'application.",
	not_allowed_title: "Pas d'accès à cette page",
	not_allowed_text: "Votre rôle n'inclut pas cette page. Un administrateur peut le modifier.",
	skip_to_content: "Aller au contenu",
	menu_open: "Ouvrir le menu",
	menu_close: "Fermer le menu",
	search: "Rechercher",
	search_pages: "Aller à une page…",
	search_none: "Aucune page ne correspond",
	account: "Compte",
	alarms_open: "%1$s alarmes ouvertes",
	devices: "Appareils",
	devices_n: {
		one: "%1$s appareil",
		other: "%1$s appareils"
	},
	search_devices: "Rechercher nom ou numéro de série",
	label_filter: "Étiquette",
	label_value: "Valeur de l'étiquette",
	label_any: "Toute valeur",
	no_device_match: "Aucun appareil ne correspond",
	no_devices_title: "Pas encore d'appareils",
	no_devices_text: "Les appareils apparaissent ici une fois enregistrés.",
	col_contact: "Contact",
	col_serial: "Numéro de série de l'appareil",
	col_name: "Nom",
	col_type: "Type",
	col_battery: "Batterie",
	col_last_seen: "Dernier contact",
	contact_good: "Contact dans les dernières 24 h",
	contact_neutral: "Dernier contact il y a 1 à 7 jours",
	contact_warn: "Aucun contact depuis plus de 7 jours",
	battery_low: "Faible",
	battery_ok: "OK",
	never: "jamais",
	settings: "Paramètres",
	api_access: "API",
	api_keys: "Clés",
	api_calls: "Appels",
	api_docs: "Documentation de l'API",
	api_key_new: "Nouvelle clé",
	api_cannot_create: "Vous ne pouvez accorder aucune portée dans vos comptes",
	api_expiry_warning: {
		one: "%1$s clé a expiré ou expire dans les 30 jours - renouvelez-la pour que les intégrations continuent de fonctionner.",
		other: "%1$s clés ont expiré ou expirent dans les 30 jours - renouvelez-les pour que les intégrations continuent de fonctionner."
	},
	api_show_revoked: "Afficher les clés révoquées",
	api_no_keys: "Aucune clé d'API pour l'instant",
	api_no_keys_text: "Une clé permet à votre propre backend d'appeler l'API.",
	api_scopes: "Portées",
	api_account: "Compte",
	api_account_root: "Tout le locataire",
	api_account_hint: "La clé voit ce compte et les comptes en dessous.",
	api_rate: "Limite de débit",
	api_rate_min: "%1$s/min",
	api_burst_value: "rafale %1$s",
	api_quota_value: "%1$s par jour",
	api_created: "Créée",
	api_last_used: "Dernière utilisation",
	api_expires: "Expire",
	api_actions: "Actions",
	api_by_support: "Support Gimasi",
	api_by_security: "Sécurité Gimasi",
	api_state_active: "Active",
	api_state_revoked: "Révoquée",
	api_state_expired: "Expirée",
	api_state_expiring: {
		one: "Expire dans %1$s jour",
		other: "Expire dans %1$s jours"
	},
	api_state_rotating: {
		one: "Remplacée, valable encore %1$s jour",
		other: "Remplacée, valable encore %1$s jours"
	},
	api_scope_read: "Lecture",
	api_scope_read_text: "chaque GET : appareils, données, alarmes",
	api_scope_config: "Configuration",
	api_scope_config_text: "modifier la configuration des appareils",
	api_scope_commands: "Commandes",
	api_scope_commands_text: "envoyer des commandes aux appareils",
	api_scope_ui: "Backend de site web",
	api_scope_ui_text: "agit pour ses utilisateurs connectés (X-Glm-User)",
	api_rotate: "Renouveler",
	api_revoke: "Révoquer",
	api_rotate_title: "Renouveler %1$s",
	api_revoke_title: "Révoquer %1$s",
	api_rotate_text: "Un nouveau secret est émis. L'ancien reste valable 7 jours, le temps de mettre à jour votre backend.",
	api_revoke_text: "La clé cesse de fonctionner dans les 30 secondes. Cette action est irréversible.",
	api_secret_title: "Votre nouvelle clé",
	api_secret_once: "Copiez maintenant le secret de %1$s et conservez-le en lieu sûr : il n'est affiché qu'une seule fois.",
	api_secret: "Secret",
	api_copy: "Copier",
	api_copied: "Copié",
	api_secret_done: "Je l'ai enregistré",
	api_err_name: "Donnez un nom à la clé",
	api_err_scopes: "Choisissez au moins une portée",
	api_err_range: "Entre %1$s et %2$s",
	api_err_form: "Veuillez corriger les champs signalés",
	api_rate_per_min: "Requêtes par minute",
	api_rate_max: "Au plus %1$s (votre offre)",
	api_burst: "Rafale",
	api_daily_quota: "Quota journalier (facultatif)",
	api_quota_none: "Aucun quota",
	api_valid_days: "Valable (jours)",
	api_valid_until: "Jusqu'au %1$s",
	api_create: "Créer la clé",
	api_range: "Période",
	api_range_1h: "Dernière heure",
	api_range_24h: "Dernières 24 heures",
	api_range_7d: "7 derniers jours",
	api_range_30d: "30 derniers jours",
	api_range_90d: "90 derniers jours",
	api_key: "Clé",
	api_all_keys: "Toutes les clés",
	api_status: "Statut",
	api_all_statuses: "Tout statut",
	api_status_2xx: "Succès (2xx)",
	api_status_4xx: "Refusées (4xx)",
	api_status_429: "Limite atteinte (429)",
	api_status_5xx: "Erreur serveur (5xx)",
	api_path: "Chemin",
	api_path_placeholder: "Chemin, p. ex. /api/v1/devices",
	api_totals: "Appels par clé et par jour (UTC)",
	api_total: "Total",
	api_errors: "Erreurs",
	api_throttled: "Limités",
	api_no_calls: "Aucun appel sur cette période",
	api_no_calls_text: "Seules les requêtes faites avec des clés d'API sont listées, pas celles des applications.",
	api_time: "Heure",
	api_request: "Requête",
	api_duration: "Durée",
	api_bytes: "Taille",
	api_bytes_in: "Taille de la requête",
	api_bytes_out: "Taille de la réponse",
	api_key_gone: "Clé supprimée",
	api_call_detail: "Appel",
	api_error_code: "Code d'erreur",
	api_client_ip: "IP du client",
	api_user_agent: "Agent utilisateur",
	api_request_id: "ID de requête"
}, Se = {
	loading: "Caricamento…",
	error_title: "Qualcosa è andato storto",
	retry: "Riprova",
	close: "Chiudi",
	pager: "Pagine",
	pager_range: "%1$s–%2$s di %3$s",
	pager_prev: "Pagina precedente",
	pager_next: "Pagina successiva",
	pager_size: "Righe per pagina",
	pager_per_page: "%1$s per pagina",
	pager_page: "Pagina %1$s",
	pager_newer: "Più recenti",
	pager_older: "Meno recenti",
	pager_newest: "I più recenti",
	days_unit: "giorni",
	in_future: "tra %1$s",
	just_now: "proprio ora",
	ago: "%1$s fa",
	all_devices: "tutti i dispositivi",
	sign_in: "Accedi",
	sign_out: "Esci",
	signing_in: "Accesso in corso…",
	signin_title: "Accedi a %1$s",
	signin_text: "Acceda con il Suo account aziendale.",
	dev_mode: "Sviluppo: chiave API invece dell'accesso",
	no_role_title: "Nessun accesso per ora",
	no_role_text: "Il Suo account è noto, ma un amministratore non Le ha ancora assegnato un ruolo.",
	config_error: "Impossibile caricare config.json (%1$s)",
	language: "Lingua",
	scheme: "Schema colori",
	scheme_auto: "Auto",
	scheme_light: "Chiaro",
	scheme_dark: "Scuro",
	debug_title: "Sessione",
	debug_text: "Cosa dice la tenant API di questa sessione (/whoami e /me).",
	menu_main: "Menu principale",
	not_found_title: "Pagina non trovata",
	not_found_text: "Questo indirizzo non esiste nell'applicazione.",
	not_allowed_title: "Nessun accesso a questa pagina",
	not_allowed_text: "Il Suo ruolo non comprende questa pagina. Un amministratore può modificarlo.",
	skip_to_content: "Vai al contenuto",
	menu_open: "Apri il menu",
	menu_close: "Chiudi il menu",
	search: "Cerca",
	search_pages: "Vai a una pagina…",
	search_none: "Nessuna pagina corrispondente",
	account: "Account",
	alarms_open: "%1$s allarmi aperti",
	devices: "Dispositivi",
	devices_n: {
		one: "%1$s dispositivo",
		other: "%1$s dispositivi"
	},
	search_devices: "Cerca nome o numero di serie",
	label_filter: "Etichetta",
	label_value: "Valore dell'etichetta",
	label_any: "Qualsiasi valore",
	no_device_match: "Nessun dispositivo corrispondente",
	no_devices_title: "Ancora nessun dispositivo",
	no_devices_text: "I dispositivi compaiono qui una volta registrati.",
	col_contact: "Contatto",
	col_serial: "Seriale del dispositivo",
	col_name: "Nome",
	col_type: "Tipo",
	col_battery: "Batteria",
	col_last_seen: "Ultimo contatto",
	contact_good: "Contatto nelle ultime 24 h",
	contact_neutral: "Ultimo contatto da 1 a 7 giorni fa",
	contact_warn: "Nessun contatto da più di 7 giorni",
	battery_low: "Scarica",
	battery_ok: "OK",
	never: "mai",
	settings: "Impostazioni",
	api_access: "API",
	api_keys: "Chiavi",
	api_calls: "Chiamate",
	api_docs: "Documentazione API",
	api_key_new: "Nuova chiave",
	api_cannot_create: "Non può assegnare alcun ambito nei suoi account",
	api_expiry_warning: {
		one: "%1$s chiave è scaduta o scade entro 30 giorni: la rinnovi perché le integrazioni continuino a funzionare.",
		other: "%1$s chiavi sono scadute o scadono entro 30 giorni: le rinnovi perché le integrazioni continuino a funzionare."
	},
	api_show_revoked: "Mostra chiavi revocate",
	api_no_keys: "Ancora nessuna chiave API",
	api_no_keys_text: "Una chiave permette al suo backend di chiamare l'API.",
	api_scopes: "Ambiti",
	api_account: "Account",
	api_account_root: "Intero tenant",
	api_account_hint: "La chiave vede questo account e quelli sottostanti.",
	api_rate: "Limite di frequenza",
	api_rate_min: "%1$s/min",
	api_burst_value: "picco %1$s",
	api_quota_value: "%1$s al giorno",
	api_created: "Creata",
	api_last_used: "Ultimo uso",
	api_expires: "Scade",
	api_actions: "Azioni",
	api_by_support: "Supporto Gimasi",
	api_by_security: "Sicurezza Gimasi",
	api_state_active: "Attiva",
	api_state_revoked: "Revocata",
	api_state_expired: "Scaduta",
	api_state_expiring: {
		one: "Scade tra %1$s giorno",
		other: "Scade tra %1$s giorni"
	},
	api_state_rotating: {
		one: "Sostituita, valida ancora %1$s giorno",
		other: "Sostituita, valida ancora %1$s giorni"
	},
	api_scope_read: "Lettura",
	api_scope_read_text: "ogni GET: dispositivi, dati, allarmi",
	api_scope_config: "Configurazione",
	api_scope_config_text: "modificare le configurazioni dei dispositivi",
	api_scope_commands: "Comandi",
	api_scope_commands_text: "inviare comandi ai dispositivi",
	api_scope_ui: "Backend di un sito web",
	api_scope_ui_text: "agisce per i suoi utenti autenticati (X-Glm-User)",
	api_rotate: "Rinnova",
	api_revoke: "Revoca",
	api_rotate_title: "Rinnova %1$s",
	api_revoke_title: "Revoca %1$s",
	api_rotate_text: "Viene emesso un nuovo segreto. Quello vecchio resta valido per 7 giorni, per aggiornare il suo backend.",
	api_revoke_text: "La chiave smette di funzionare entro 30 secondi. L'operazione non è reversibile.",
	api_secret_title: "La sua nuova chiave",
	api_secret_once: "Copi ora il segreto di %1$s e lo conservi al sicuro: viene mostrato solo questa volta.",
	api_secret: "Segreto",
	api_copy: "Copia",
	api_copied: "Copiato",
	api_secret_done: "L'ho salvato",
	api_err_name: "Dia un nome alla chiave",
	api_err_scopes: "Scelga almeno un ambito",
	api_err_range: "Tra %1$s e %2$s",
	api_err_form: "Corregga i campi evidenziati",
	api_rate_per_min: "Richieste al minuto",
	api_rate_max: "Al massimo %1$s (il suo piano)",
	api_burst: "Picco",
	api_daily_quota: "Quota giornaliera (facoltativa)",
	api_quota_none: "Nessuna quota",
	api_valid_days: "Valida per (giorni)",
	api_valid_until: "Fino al %1$s",
	api_create: "Crea chiave",
	api_range: "Periodo",
	api_range_1h: "Ultima ora",
	api_range_24h: "Ultime 24 ore",
	api_range_7d: "Ultimi 7 giorni",
	api_range_30d: "Ultimi 30 giorni",
	api_range_90d: "Ultimi 90 giorni",
	api_key: "Chiave",
	api_all_keys: "Tutte le chiavi",
	api_status: "Stato",
	api_all_statuses: "Qualsiasi stato",
	api_status_2xx: "Riuscite (2xx)",
	api_status_4xx: "Rifiutate (4xx)",
	api_status_429: "Limite raggiunto (429)",
	api_status_5xx: "Errore del server (5xx)",
	api_path: "Percorso",
	api_path_placeholder: "Percorso, ad es. /api/v1/devices",
	api_totals: "Chiamate per chiave e giorno (UTC)",
	api_total: "Totale",
	api_errors: "Errori",
	api_throttled: "Limitate",
	api_no_calls: "Nessuna chiamata in questo periodo",
	api_no_calls_text: "Sono elencate solo le richieste fatte con chiavi API, non quelle delle applicazioni.",
	api_time: "Ora",
	api_request: "Richiesta",
	api_duration: "Durata",
	api_bytes: "Dimensione",
	api_bytes_in: "Dimensione richiesta",
	api_bytes_out: "Dimensione risposta",
	api_key_gone: "Chiave eliminata",
	api_call_detail: "Chiamata",
	api_error_code: "Codice di errore",
	api_client_ip: "IP del client",
	api_user_agent: "User agent",
	api_request_id: "ID richiesta"
}, Ce = [
	"en",
	"de",
	"it",
	"fr"
], we = "gs.lang", Te = (e) => (e || "").slice(0, 2).toLowerCase(), I = o(Ce);
function Ee(e, t) {
	for (let n of e) {
		let e = Te(n);
		if (e && t.includes(e)) return e;
	}
	return t[0] || "en";
}
function De() {
	try {
		return localStorage.getItem(we);
	} catch {
		return null;
	}
}
var Oe = () => typeof navigator < "u" ? [...navigator.languages || [], navigator.language] : [], L = o(Ee([De(), ...Oe()], Ce));
function ke(e) {
	let t = Array.isArray(e) ? [...new Set(e.map((e) => Te(String(e))).filter((e) => /^[a-z]{2}$/.test(e)))] : [];
	I.value = t.length ? t : ["en"], I.value.includes(L.value) || je(Ee([De(), ...Oe()], I.value), !1);
}
function Ae(e, t) {
	je(Ee([
		e,
		De(),
		t,
		...Oe()
	], I.value), !1);
}
function je(e, t = !0) {
	if (L.value = e, typeof document < "u" && (document.documentElement.lang = e), t) try {
		localStorage.setItem(we, e);
	} catch {}
}
function Me(e) {
	try {
		let t = new Intl.DisplayNames([e], { type: "language" }).of(e) || e;
		return t.charAt(0).toLocaleUpperCase(e) + t.slice(1);
	} catch {
		return e.toUpperCase();
	}
}
var Ne = [{
	en: be,
	de: ye,
	it: Se,
	fr: xe
}];
function Pe(e) {
	let t = {
		en: {},
		de: {}
	};
	for (let [n, r] of Object.entries(e)) r[0] !== void 0 && (t.en[n] = r[0]), r[1] && (t.de[n] = r[1]);
	return t;
}
var Fe = (e) => Object.values(e).some((e) => Array.isArray(e));
function Ie(e) {
	Ne.unshift(Fe(e) ? Pe(e) : e);
}
function Le(e, t) {
	for (let n of Ne) {
		let r = n[t]?.[e];
		if (r !== void 0) return r;
	}
}
function Re(e, t) {
	return e.replace(/%(\d)\$[sd]/g, (e, n) => String(t[n - 1])).replace(/%(\d)\$\.(\d)f/g, (e, n, r) => Number(t[n - 1]).toFixed(+r)).replace(/\{(\d)\}/g, (e, n) => String(t[+n]));
}
var ze = /* @__PURE__ */ new Map();
function Be(e, t, n) {
	let r = ze.get(t);
	r || ze.set(t, r = new Intl.PluralRules(t));
	let i = Number(n);
	return i === 0 && e.zero !== void 0 ? e.zero : e[r.select(Number.isFinite(i) ? i : 0)] ?? e.other;
}
function R(e, ...t) {
	let n = L.value, r = Le(e, n), i = n;
	return r === void 0 && n !== "en" && (r = Le(e, "en"), i = "en"), r === void 0 ? e : Re(typeof r == "string" ? r : Be(r, i, t[0]), t);
}
var Ve = (e) => Le(e, L.value) !== void 0 || Le(e, "en") !== void 0;
function He(e) {
	return e ? typeof e == "string" ? Ve(e) ? R(e) : e : e[L.value] ?? e.en ?? Object.values(e)[0] ?? "" : "";
}
var Ue = a(() => Me(L.value)), z = o(null), B = o(null);
async function We() {
	let [e, t] = await Promise.all([F.whoami(), F.me().catch(() => null)]);
	z.value = e, B.value = t;
	let n = t?.settings?.locale;
	Ae(n, n ? null : await F.tenantSettings().then((e) => e.defaults?.locale, () => null)), qe();
}
async function Ge() {
	try {
		let e = await F.me();
		JSON.stringify(e) !== JSON.stringify(B.value) && (B.value = e);
	} catch {}
}
var Ke = !1;
function qe() {
	Ke || (Ke = !0, setInterval(Ge, 6e4), document.addEventListener("visibilitychange", () => {
		document.visibilityState === "visible" && Ge();
	}), window.addEventListener("glm:ai-disabled", () => {
		Ge();
	}));
}
var Je = a(() => new Set(B.value?.permissions ?? z.value?.permissions ?? []));
function V(e) {
	return e.split("|").some((e) => Je.value.has(e));
}
function Ye(e) {
	let t = B.value?.scopes?.[e];
	return t ? t.some((e) => Object.keys(e).length === 0) : z.value?.kind === "key" && V(e);
}
var Xe = a(() => B.value?.ai?.ui_enabled !== !1), Ze = a(() => B.value?.name || z.value?.principal || ""), Qe = a(() => Je.value.size > 0), H = o("off");
function $e(e, t) {
	let n = !1, r = null, i = 1e3;
	return (async () => {
		for (; !n;) {
			r = new AbortController(), H.value = "connecting";
			try {
				let n = await re(), a = await fetch(D().api_base + e, {
					headers: {
						Accept: "text/event-stream",
						...n ? { Authorization: "Bearer " + n } : {}
					},
					signal: r.signal
				});
				if (a.status === 503 || a.status === 404 || a.status === 403) {
					H.value = "off", await et(6e4);
					continue;
				}
				if (!a.ok || !a.body) throw Error("stream " + a.status);
				H.value = "live", i = 1e3;
				let o = a.body.pipeThrough(new TextDecoderStream()).getReader(), s = "";
				for (;;) {
					let { value: e, done: n } = await o.read();
					if (n) break;
					s += e;
					let r;
					for (; (r = s.indexOf("\n\n")) >= 0;) {
						let e = s.slice(0, r);
						s = s.slice(r + 2);
						let n = "message", i = "";
						for (let t of e.split("\n")) t.startsWith("event: ") ? n = t.slice(7) : t.startsWith("data: ") && (i += t.slice(6));
						if (!i) continue;
						let a = i;
						try {
							a = JSON.parse(i);
						} catch {}
						t({
							event: n,
							data: a
						});
					}
				}
			} catch {
				if (n) break;
			}
			if (n) break;
			H.value = "connecting", await et(i), i = Math.min(i * 2, 3e4);
		}
		H.value = "off";
	})(), () => {
		n = !0, r?.abort();
	};
}
var et = (e) => new Promise((t) => setTimeout(t, e));
function tt(e, t) {
	let n = l(t);
	n.current = t, s(() => {
		let t, r = null, i = $e(`/devices/${encodeURIComponent(e)}/stream`, (e) => {
			(e.event === "device" || e.event === "resync") && (r = e, clearTimeout(t), t = setTimeout(() => r && n.current(r), 500));
		});
		return () => {
			clearTimeout(t), i();
		};
	}, [e]);
}
function nt(e, t) {
	let n = l(t);
	n.current = t;
	let r = [...e].sort().join(",");
	s(() => {
		if (r) return $e(`/stream?device_ids=${encodeURIComponent(r)}`, (e) => {
			e.event === "changed" && n.current(e.data.device_ids || []), e.event === "resync" && n.current("all");
		});
	}, [r]);
}
//#endregion
//#region src/lib/prefs.ts
var rt = (() => {
	try {
		return Intl.DateTimeFormat().resolvedOptions().timeZone || "Europe/Zurich";
	} catch {
		return "Europe/Zurich";
	}
})(), it = [
	"en-GB",
	"en-US",
	"de-CH",
	"de-DE",
	"de-AT",
	"it-CH",
	"it-IT",
	"fr-CH",
	"fr-FR"
];
function at() {
	let e = navigator.language || "en-GB";
	if (it.includes(e)) return e;
	let t = e.slice(0, 2);
	return it.find((e) => e.startsWith(t + "-")) || "en-GB";
}
var U = a(() => B.value?.settings?.timezone || rt);
function ot(e, t, n = it) {
	let r = t?.split("-")[1], i = n.filter((t) => t.startsWith(e + "-"));
	return i.find((e) => e.split("-")[1] === r) || i[0] || null;
}
var st = a(() => {
	let e = B.value?.settings?.locale;
	if (e) return e;
	let t = at();
	return t.startsWith(L.value + "-") ? t : ot(L.value, t) || t;
}), ct = {
	timezone: rt,
	locale: at()
}, lt = (e) => e.slice(0, 2).toLowerCase();
function ut(e) {
	je(e);
	let t = ++dt;
	return ft = ft.then(async () => {
		let n = B.value;
		if (t !== dt || n?.kind !== "user") return;
		let r = ot(e, n.settings?.locale || st.value, n.locales?.length ? n.locales : it);
		if (r && r !== n.settings?.locale) try {
			let e = await F.putSettings({ locale: r });
			B.value = {
				...n,
				settings: {
					...n.settings,
					...e
				}
			};
		} catch {}
	}), ft;
}
var dt = 0, ft = Promise.resolve(), W = () => st.value, pt = (e) => typeof e == "number" ? e < 1e11 ? e * 1e3 : e : Date.parse(e), G = {
	time: (e) => e ? new Intl.DateTimeFormat(W(), {
		timeZone: U.value,
		day: "2-digit",
		month: "short",
		hour: "2-digit",
		minute: "2-digit"
	}).format(pt(e)) : "–",
	timeY: (e) => e ? new Intl.DateTimeFormat(W(), {
		timeZone: U.value,
		day: "2-digit",
		month: "short",
		year: "numeric",
		hour: "2-digit",
		minute: "2-digit"
	}).format(pt(e)) : "–",
	day: (e) => e ? new Intl.DateTimeFormat(W(), {
		timeZone: U.value,
		day: "numeric",
		month: "short",
		year: "numeric"
	}).format(pt(e)) : "–",
	dt: (e) => e ? new Intl.DateTimeFormat(W(), {
		timeZone: U.value,
		year: "numeric",
		month: "2-digit",
		day: "2-digit",
		hour: "2-digit",
		minute: "2-digit",
		second: "2-digit"
	}).format(pt(e)) : "–",
	hm: (e) => new Intl.DateTimeFormat(W(), {
		timeZone: U.value,
		hour: "2-digit",
		minute: "2-digit"
	}).format(pt(e)),
	num: (e) => e == null ? "–" : new Intl.NumberFormat(W()).format(e),
	dec: (e, t) => new Intl.NumberFormat(W(), {
		minimumFractionDigits: t,
		maximumFractionDigits: t
	}).format(e),
	dur(e) {
		return e = Math.abs(Math.round(e)), e < 90 ? e + " s" : e < 5400 ? Math.round(e / 60) + " min" : e < 129600 ? Math.round(e / 3600) + " h" : G.dec(e / 86400, +(e < 864e3)) + " " + R("days_unit");
	},
	ago(e) {
		if (!e) return "–";
		let t = Math.round((Date.now() - pt(e)) / 1e3);
		return t < 0 ? R("in_future", G.dur(-t)) : t < 60 ? R("just_now") : R("ago", G.dur(t));
	}
};
function mt(e, t) {
	return e?.[t]?.value;
}
function ht(e) {
	let t = Object.entries(e);
	return t.length ? t.map(([e, t]) => `${e} = ${t}`).join(", ") : R("all_devices");
}
//#endregion
//#region src/ui/primitives.tsx
var gt = {
	home: "<path d=\"M3 11l9-7 9 7\"/><path d=\"M5 10v10h14V10\"/>",
	grid: "<rect x=\"3\" y=\"3\" width=\"8\" height=\"10\" rx=\"1.5\"/><rect x=\"13\" y=\"3\" width=\"8\" height=\"6\" rx=\"1.5\"/><rect x=\"13\" y=\"11\" width=\"8\" height=\"10\" rx=\"1.5\"/><rect x=\"3\" y=\"15\" width=\"8\" height=\"6\" rx=\"1.5\"/>",
	list: "<path d=\"M8 6h13M8 12h13M8 18h13\"/><circle cx=\"3.5\" cy=\"6\" r=\"1\"/><circle cx=\"3.5\" cy=\"12\" r=\"1\"/><circle cx=\"3.5\" cy=\"18\" r=\"1\"/>",
	bell: "<path d=\"M6 8a6 6 0 1112 0c0 7 3 8 3 8H3s3-1 3-8\"/><path d=\"M10 20a2 2 0 004 0\"/>",
	users: "<circle cx=\"9\" cy=\"8\" r=\"3.5\"/><path d=\"M2.5 20c.8-3.6 3.4-5.5 6.5-5.5s5.7 1.9 6.5 5.5\"/><path d=\"M16 4.5a3.5 3.5 0 010 7M18 14.8c1.8.8 3 2.6 3.5 5.2\"/>",
	cog: "<circle cx=\"12\" cy=\"12\" r=\"3\"/><path d=\"M12 2v3M12 19v3M2 12h3M19 12h3M4.9 4.9l2.1 2.1M17 17l2.1 2.1M4.9 19.1L7 17M17 7l2.1-2.1\"/>",
	layers: "<path d=\"M12 3l9 5-9 5-9-5z\"/><path d=\"M3 13l9 5 9-5\"/>",
	bolt: "<path d=\"M13 2L4 14h7l-1 8 9-12h-7z\"/>",
	search: "<circle cx=\"11\" cy=\"11\" r=\"7\"/><path d=\"M20 20l-3.5-3.5\"/>",
	alert: "<path d=\"M12 3l9.5 17h-19z\"/><path d=\"M12 10v4M12 17.5v.5\"/>",
	chevron: "<path d=\"M9 6l6 6-6 6\"/>",
	logout: "<path d=\"M15 4h4v16h-4M10 8l-4 4 4 4M6 12h10\"/>",
	hourglass: "<path d=\"M6 3h12M6 21h12M7 3c0 6 10 6 10 9s-10 3-10 9M17 3c0 6-10 6-10 9\"/>",
	tag: "<path d=\"M3 12V4h8l10 10-8 8z\"/><circle cx=\"7.5\" cy=\"8.5\" r=\"1.5\"/>",
	box: "<path d=\"M3 7l9-4 9 4v10l-9 4-9-4z\"/><path d=\"M3 7l9 4 9-4M12 11v10\"/>",
	truck: "<path d=\"M2 6h11v10H2zM13 10h4l3 3v3h-7z\"/><circle cx=\"6\" cy=\"18\" r=\"2\"/><circle cx=\"17\" cy=\"18\" r=\"2\"/>",
	star: "<path d=\"M12 3l2.8 5.8 6.2.9-4.5 4.4 1.1 6.3L12 17.5 6.4 20.4l1.1-6.3L3 9.7l6.2-.9z\"/>",
	plus: "<path d=\"M12 5v14M5 12h14\"/>",
	link: "<path d=\"M10 14a4 4 0 005.7 0l3-3a4 4 0 00-5.7-5.7l-1 1\"/><path d=\"M14 10a4 4 0 00-5.7 0l-3 3a4 4 0 005.7 5.7l1-1\"/>",
	history: "<path d=\"M3 12a9 9 0 103-6.7L3 8\"/><path d=\"M3 3v5h5M12 7v5l3 3\"/>",
	menu: "<path d=\"M4 6h16M4 12h16M4 18h16\"/>",
	x: "<path d=\"M6 6l12 12M18 6L6 18\"/>",
	updown: "<path d=\"M8 9l4-4 4 4M8 15l4 4 4-4\"/>",
	sun: "<circle cx=\"12\" cy=\"12\" r=\"4\"/><path d=\"M12 2v2M12 20v2M2 12h2M20 12h2M4.9 4.9l1.4 1.4M17.7 17.7l1.4 1.4M4.9 19.1l1.4-1.4M17.7 6.3l1.4-1.4\"/>",
	key: "<circle cx=\"7.5\" cy=\"15.5\" r=\"4.5\"/><path d=\"M10.7 12.3L20 3M16 7l3 3M14 9l2 2\"/>",
	globe: "<circle cx=\"12\" cy=\"12\" r=\"9\"/><path d=\"M3 12h18M12 3c2.5 2.6 3.8 5.6 3.8 9s-1.3 6.4-3.8 9c-2.5-2.6-3.8-5.6-3.8-9s1.3-6.4 3.8-9z\"/>"
};
function K({ n: e, class: n = "size-4" }) {
	return /* @__PURE__ */ t("svg", {
		class: n,
		viewBox: "0 0 24 24",
		fill: "none",
		stroke: "currentColor",
		"stroke-width": "2",
		"stroke-linecap": "round",
		"stroke-linejoin": "round",
		"aria-hidden": "true",
		dangerouslySetInnerHTML: { __html: gt[e] || "" }
	});
}
function _t({ title: r, sub: i, right: a, crumbs: o }) {
	return /* @__PURE__ */ n("div", {
		class: "mb-5",
		children: [o && /* @__PURE__ */ t("nav", {
			class: "text-sm text-muted mb-1 flex flex-wrap items-center gap-1",
			"aria-label": "Breadcrumb",
			children: o.map(([r, i], a) => /* @__PURE__ */ n(e, { children: [i ? /* @__PURE__ */ t("a", {
				href: i,
				class: "hover:underline",
				children: r
			}) : /* @__PURE__ */ t("span", { children: r }), a < o.length - 1 && /* @__PURE__ */ t(K, {
				n: "chevron",
				class: "size-3.5"
			})] }))
		}), /* @__PURE__ */ n("div", {
			class: "flex flex-wrap items-end justify-between gap-3",
			children: [/* @__PURE__ */ n("div", {
				class: "min-w-0",
				children: [/* @__PURE__ */ t("h1", {
					class: "text-2xl font-bold tracking-tight text-ink",
					children: r
				}), i && /* @__PURE__ */ t("div", {
					class: "text-sm text-muted mt-1",
					children: i
				})]
			}), a && /* @__PURE__ */ t("div", {
				class: "flex flex-wrap gap-2",
				children: a
			})]
		})]
	});
}
var q = ({ kind: e, children: n, title: r }) => /* @__PURE__ */ t("span", {
	class: `chip chip-${e}`,
	title: r,
	children: n
}), J = () => /* @__PURE__ */ n("div", {
	class: "py-16 text-center text-muted text-sm",
	"aria-busy": "true",
	children: [/* @__PURE__ */ t("div", { class: "mx-auto mb-3 size-8 rounded-full border-4 border-primary-soft border-t-primary animate-spin" }), R("loading")]
});
function vt({ error: e }) {
	let r = e instanceof Error ? e.message : String(e);
	return /* @__PURE__ */ n("div", {
		class: "card p-6 text-center",
		children: [
			/* @__PURE__ */ t("div", {
				class: "mx-auto mb-3 size-12 rounded-full bg-crit-soft text-crit flex items-center justify-center",
				children: /* @__PURE__ */ t(K, {
					n: "alert",
					class: "size-6"
				})
			}),
			/* @__PURE__ */ t("div", {
				class: "font-semibold",
				children: R("error_title")
			}),
			/* @__PURE__ */ t("div", {
				class: "text-sm text-muted mt-1",
				children: r
			}),
			/* @__PURE__ */ t("button", {
				class: "btn mt-4",
				onClick: () => location.reload(),
				children: R("retry")
			})
		]
	});
}
var Y = ({ title: e, text: r, icon: i = "search" }) => /* @__PURE__ */ n("div", {
	class: "text-center py-10 px-4",
	children: [
		/* @__PURE__ */ t("div", {
			class: "mx-auto mb-3 size-12 rounded-full bg-neutral-soft text-neutral flex items-center justify-center",
			children: /* @__PURE__ */ t(K, {
				n: i,
				class: "size-6"
			})
		}),
		/* @__PURE__ */ t("div", {
			class: "font-semibold",
			children: e
		}),
		r && /* @__PURE__ */ t("div", {
			class: "text-sm text-muted mt-1",
			children: r
		})
	]
});
//#endregion
//#region src/ui/Dialog.tsx
function yt({ open: e, title: r, onClose: i, children: a, wide: o }) {
	let c = l(null);
	return s(() => {
		let t = c.current;
		t && (e && !t.open && t.showModal(), !e && t.open && t.close());
	}, [e]), /* @__PURE__ */ n("dialog", {
		ref: c,
		onClose: i,
		onClick: (e) => e.target === c.current && i(),
		class: `card p-0 m-auto max-h-[90vh] backdrop:bg-black/50 ${o ? "w-[min(56rem,calc(100vw-2rem))]" : "w-[min(36rem,calc(100vw-2rem))]"}`,
		children: [/* @__PURE__ */ n("div", {
			class: "card-h sticky top-0 bg-surface z-10 border-b border-line pb-3",
			children: [/* @__PURE__ */ t("span", { children: r }), /* @__PURE__ */ t("button", {
				type: "button",
				class: "btn btn-sm",
				onClick: i,
				children: R("close")
			})]
		}), /* @__PURE__ */ t("div", {
			class: "p-4",
			children: e && a
		})]
	});
}
function bt(e) {
	let t = e, n = {};
	for (let e of t?.field_errors || []) n[e.key] = e.detail ? `${e.code}: ${e.detail}` : e.code;
	return {
		message: t?.message || String(e),
		fields: n
	};
}
//#endregion
//#region src/ui/Pager.tsx
var xt = [
	25,
	50,
	100,
	200
];
function St(e) {
	try {
		return JSON.parse(sessionStorage.getItem("gs.page." + e) || "{}");
	} catch {
		return {};
	}
}
function Ct(e, t) {
	try {
		sessionStorage.setItem("gs.page." + e, JSON.stringify(t));
	} catch {}
}
function wt(e, t = 50) {
	let n = c(() => St(e), [e]), [r, i] = u(n.page && n.page > 0 ? n.page : 1), [a, o] = u(n.size && xt.includes(n.size) ? n.size : t);
	return s(() => Ct(e, {
		page: r,
		size: a
	}), [
		e,
		r,
		a
	]), {
		page: r,
		size: a,
		setPage: i,
		setSize: (e) => {
			o(e), i(1);
		}
	};
}
function Tt(e, t, n = 50) {
	let r = wt(t, n), i = e?.length || 0, a = Math.max(1, Math.ceil(i / r.size)), o = Math.min(r.page, a);
	return {
		rows: (e || []).slice((o - 1) * r.size, o * r.size),
		pager: {
			page: o,
			size: r.size,
			total: i,
			onPage: r.setPage,
			onSize: r.setSize
		}
	};
}
function Et({ page: e, size: r, total: i, onPage: a, onSize: o, sizes: s = xt }) {
	let c = Math.max(1, Math.ceil(i / r));
	if (i <= Math.min(r, s[0])) return null;
	let l = i ? (e - 1) * r + 1 : 0, u = Math.min(i, e * r), d = [];
	for (let t = 1; t <= c; t++) t === 1 || t === c || Math.abs(t - e) <= 2 ? d.push(t) : d[d.length - 1] !== "…" && d.push("…");
	return /* @__PURE__ */ n("nav", {
		class: "flex flex-wrap items-center justify-between gap-2 p-3 border-t border-line text-sm",
		"aria-label": R("pager"),
		children: [/* @__PURE__ */ t("span", {
			class: "text-muted tabular-nums",
			children: R("pager_range", G.num(l), G.num(u), G.num(i))
		}), /* @__PURE__ */ n("div", {
			class: "flex flex-wrap items-center gap-1",
			children: [
				/* @__PURE__ */ t("button", {
					class: "btn btn-sm",
					disabled: e <= 1,
					onClick: () => a(e - 1),
					"aria-label": R("pager_prev"),
					children: "‹"
				}),
				d.map((n) => n === "…" ? /* @__PURE__ */ t("span", {
					class: "px-1 text-muted",
					children: "…"
				}) : /* @__PURE__ */ t("button", {
					class: `btn btn-sm tabular-nums ${n === e ? "btn-primary" : ""}`,
					"aria-current": n === e ? "page" : void 0,
					onClick: () => a(n),
					children: n
				})),
				/* @__PURE__ */ t("button", {
					class: "btn btn-sm",
					disabled: e >= c,
					onClick: () => a(e + 1),
					"aria-label": R("pager_next"),
					children: "›"
				}),
				o && /* @__PURE__ */ t("select", {
					class: "field w-auto text-sm ml-2",
					value: r,
					"aria-label": R("pager_size"),
					onChange: (e) => o(Number(e.target.value)),
					children: s.map((e) => /* @__PURE__ */ t("option", {
						value: e,
						children: R("pager_per_page", e)
					}))
				})
			]
		})]
	});
}
function Dt(e, t) {
	let [n, r] = u([void 0]), [i, a] = u(null), [o, c] = u(null), [d, f] = u(!0), [p, m] = u(0), h = l(0), g = JSON.stringify(t), _ = l(!0);
	s(() => {
		_.current ? _.current = !1 : r([void 0]);
	}, [g]);
	let v = n[n.length - 1];
	return s(() => {
		let t = ++h.current;
		f(!0), e(v).then((e) => {
			t === h.current && (a(e), c(null));
		}).catch((e) => {
			t === h.current && c(e);
		}).finally(() => {
			t === h.current && f(!1);
		});
	}, [
		v,
		g,
		p,
		n.length
	]), {
		data: i,
		error: o,
		loading: d,
		reload: () => m((e) => e + 1),
		pager: {
			page: n.length,
			hasNewer: n.length > 1,
			hasOlder: !!i?.next_before,
			newer: () => r((e) => e.length > 1 ? e.slice(0, -1) : e),
			older: () => {
				let e = i?.next_before;
				e && r((t) => [...t, e]);
			},
			newest: () => r([void 0])
		}
	};
}
function Ot({ page: e, hasNewer: r, hasOlder: i, newer: a, older: o, newest: s }) {
	return !r && !i ? null : /* @__PURE__ */ n("nav", {
		class: "flex flex-wrap items-center justify-between gap-2 p-3 border-t border-line text-sm",
		"aria-label": R("pager"),
		children: [/* @__PURE__ */ t("span", {
			class: "text-muted",
			children: R("pager_page", e)
		}), /* @__PURE__ */ n("div", {
			class: "flex gap-1",
			children: [
				e > 2 && /* @__PURE__ */ t("button", {
					class: "btn btn-sm",
					onClick: s,
					children: R("pager_newest")
				}),
				/* @__PURE__ */ n("button", {
					class: "btn btn-sm",
					disabled: !r,
					onClick: a,
					children: ["‹ ", R("pager_newer")]
				}),
				/* @__PURE__ */ n("button", {
					class: "btn btn-sm",
					disabled: !i,
					onClick: o,
					children: [R("pager_older"), " ›"]
				})
			]
		})]
	});
}
//#endregion
//#region src/theme/theme.ts
var kt = [
	"canvas",
	"surface",
	"surface-2",
	"ink",
	"ink-2",
	"muted",
	"line",
	"line-soft",
	"primary",
	"primary-ink",
	"action",
	"action-ink",
	"attention",
	"good",
	"warn",
	"crit",
	"neutral",
	"chart-1",
	"chart-2",
	"chart-3"
], At = /* @__PURE__ */ new Map([["gimasi-light", "light"], ["gimasi-dark", "dark"]]);
function jt(e, t) {
	At.set(e, t);
}
var Mt = {
	comfortable: "0.25rem",
	compact: "0.22rem"
}, Nt = "gs.scheme", Pt = o(Lt()), Ft = o("light"), It = o({});
function Lt() {
	try {
		let e = localStorage.getItem(Nt);
		return e === "auto" || e === "light" || e === "dark" ? e : null;
	} catch {
		return null;
	}
}
var Rt = (e) => console.warn(`theme: ${e}`);
function zt(e) {
	return typeof e != "string" || !e || /[;{}]/.test(e) ? !1 : typeof CSS > "u" || !CSS.supports || CSS.supports("color", e);
}
function Bt(e) {
	return typeof e == "number" && e >= 0 && e <= 64 ? `${e}px` : typeof e == "string" && /^\d+(\.\d+)?(px|rem)$/.test(e) ? e : null;
}
function Vt(e, t) {
	let n = {}, r = {
		...e.colors || {},
		...t === "dark" && e.dark_colors || {}
	};
	for (let [e, t] of Object.entries(r)) kt.includes(e) ? zt(t) ? n[`--color-${e}`] = t : Rt(`colour ${e}: "${String(t)}" is not a colour`) : Rt(`unknown colour "${e}"`);
	for (let t of ["sans", "mono"]) {
		let r = e.fonts?.[t];
		r !== void 0 && (typeof r == "string" && r && !/[;{}]/.test(r) ? n[`--font-${t}`] = r : Rt(`font ${t}: "${String(r)}"`));
	}
	for (let t of ["control", "surface"]) {
		let r = e.radius?.[t];
		if (r === void 0) continue;
		let i = Bt(r);
		i ? n[`--radius-${t}`] = i : Rt(`radius ${t}: "${String(r)}" (px number or "<n>px"/"<n>rem")`);
	}
	return e.density !== void 0 && (Mt[e.density] ? n["--spacing"] = Mt[e.density] : Rt(`density "${String(e.density)}" (comfortable | compact)`)), n;
}
function Ht(e, t) {
	let n = t === "dark" ? e.dark_preset || "gimasi-dark" : e.preset || "gimasi-light";
	return At.get(n) === t ? n : (Rt(`preset "${n}" is not a known ${t} preset`), t === "dark" ? "gimasi-dark" : "gimasi-light");
}
var Ut = typeof matchMedia == "function" ? matchMedia("(prefers-color-scheme: dark)") : null, Wt = [];
function Gt(e) {
	let t = Pt.value || e.dark || "auto";
	return t === "auto" ? Ut?.matches ? "dark" : "light" : t === "dark" ? "dark" : "light";
}
function Kt() {
	let e = It.value, t = Gt(e), n = document.documentElement;
	for (let e of Wt) n.style.removeProperty(e);
	let r = Vt(e, t);
	for (let [e, t] of Object.entries(r)) n.style.setProperty(e, t);
	Wt = Object.keys(r), n.dataset.gsPreset = Ht(e, t), n.classList.toggle("dark", t === "dark"), Ft.value = t;
}
function qt(e = {}) {
	It.value = e && typeof e == "object" ? e : {}, Kt();
}
function Jt(e) {
	Pt.value = e;
	try {
		localStorage.setItem(Nt, e);
	} catch {}
	Kt();
}
Ut?.addEventListener("change", () => {
	(Pt.value || It.value.dark || "auto") === "auto" && Kt();
});
//#endregion
//#region src/charts/charts.tsx
var Yt = (e) => new Intl.DateTimeFormat(st.value, {
	timeZone: U.value,
	day: "2-digit",
	month: "2-digit"
}).format(e);
p.register(h, g, v, _, d, f, ee, m);
var Xt = {
	"chart-1": "#4f46e5",
	"chart-2": "#a1a1aa",
	"chart-3": "#ea580c",
	good: "#13753a",
	warn: "#b23c0b",
	crit: "#b91c1c",
	neutral: "#66666e",
	muted: "#66666e",
	line: "#e4e4e0",
	ink: "#18181b"
}, X;
function Zt(e) {
	let t = /^#([0-9a-f]{6})$/i.exec(e) || /^#([0-9a-f]{3})$/i.exec(e);
	if (t) {
		let e = t[1].length === 3 ? [...t[1]].map((e) => e + e).join("") : t[1], n = parseInt(e, 16);
		return [
			n >> 16 & 255,
			n >> 8 & 255,
			n & 255
		];
	}
	if (X === void 0 && (X = document.createElement("canvas").getContext("2d", { willReadFrequently: !0 })), !X) return null;
	X.clearRect(0, 0, 1, 1), X.fillStyle = "#000", X.fillStyle = e, X.fillRect(0, 0, 1, 1);
	let [n, r, i] = X.getImageData(0, 0, 1, 1).data;
	return [
		n,
		r,
		i
	];
}
function Qt(e, t = 1) {
	let n = getComputedStyle(document.documentElement).getPropertyValue("--color-" + e).trim() || Xt[e] || "#71717a", r = Zt(n);
	return r ? `rgba(${r[0]},${r[1]},${r[2]},${t})` : n;
}
function $t() {
	p.defaults.font.family = getComputedStyle(document.documentElement).getPropertyValue("--font-sans") || "system-ui", p.defaults.font.size = 12, p.defaults.color = Qt("muted"), p.defaults.borderColor = Qt("line"), p.defaults.animation = !1, p.defaults.maintainAspectRatio = !1, p.defaults.plugins.tooltip.backgroundColor = Qt("ink");
}
function en(e, t) {
	let n = t - e;
	return {
		type: "linear",
		min: e,
		max: t,
		grid: { color: Qt("line", .6) },
		ticks: {
			maxRotation: 0,
			autoSkip: !0,
			maxTicksLimit: 8,
			callback: (e) => n > 2592e5 ? Yt(Number(e)) : n <= 864e5 ? G.hm(Number(e)) : G.time(new Date(Number(e)).toISOString())
		}
	};
}
var tn = {
	id: "gsBands",
	beforeDatasetsDraw(e, t, n) {
		let { ctx: r, chartArea: i, scales: a } = e;
		if (n?.bands?.length) {
			r.save();
			for (let e of n.bands) {
				let t = a.y.getPixelForValue(e.from), n = a.y.getPixelForValue(e.to);
				r.fillStyle = e.color, r.fillRect(i.left, Math.min(t, n), i.right - i.left, Math.abs(n - t)), e.label && (r.fillStyle = Qt("muted"), r.font = "600 11px " + p.defaults.font.family, r.textAlign = "right", r.fillText(e.label, i.right - 6, Math.min(t, n) + 13));
			}
			r.restore();
		}
	}
};
function nn(e, t) {
	let n = [];
	return e.forEach((r, i) => {
		i && r.x - e[i - 1].x > t && n.push({
			x: (r.x + e[i - 1].x) / 2,
			y: null
		}), n.push(r);
	}), n;
}
function rn({ cfg: e, height: n = 220, label: r }) {
	let i = l(null), a = Ft.value;
	return s(() => {
		if (!i.current) return;
		$t();
		let t = new p(i.current, e);
		return () => t.destroy();
	}, [e, a]), /* @__PURE__ */ t("div", {
		style: { height: n + "px" },
		children: /* @__PURE__ */ t("canvas", {
			ref: i,
			role: "img",
			"aria-label": r
		})
	});
}
//#endregion
//#region src/app/AuthGate.tsx
function an() {
	return /* @__PURE__ */ t("div", {
		class: "min-h-screen flex items-center justify-center p-4",
		children: /* @__PURE__ */ n("div", {
			class: "card p-8 max-w-md w-full text-center",
			"data-testid": "signed-out",
			children: [
				/* @__PURE__ */ t("h1", {
					class: "text-xl font-bold",
					children: R("signin_title", D().tenant_name)
				}),
				/* @__PURE__ */ t("p", {
					class: "text-sm text-muted mt-2",
					children: R("signin_text")
				}),
				/* @__PURE__ */ t("button", {
					class: "btn btn-primary w-full mt-6",
					onClick: () => ae("/"),
					children: R("sign_in")
				})
			]
		})
	});
}
function on() {
	let [, e] = S(), [n, r] = u(null);
	return s(() => {
		oe().then((t) => {
			e(t, { replace: !0 }), location.reload();
		}, r);
	}, []), n ? /* @__PURE__ */ t("div", {
		class: "p-6",
		children: /* @__PURE__ */ t(vt, { error: n })
	}) : /* @__PURE__ */ t(J, {});
}
function sn({ children: n }) {
	let [r] = S(), [i, a] = u("starting"), [o, c] = u(null);
	return s(() => {
		r !== "/auth/callback" && (async () => {
			if (!A() && !await ie()) return a("signed-out");
			await We(), a("ready");
		})().catch((e) => {
			c(e), a("error");
		});
	}, []), r === "/auth/callback" ? /* @__PURE__ */ t(on, {}) : i === "starting" ? /* @__PURE__ */ t(J, {}) : i === "signed-out" ? /* @__PURE__ */ t(an, {}) : i === "error" ? /* @__PURE__ */ t("div", {
		class: "p-6",
		children: /* @__PURE__ */ t(vt, { error: o })
	}) : Qe.value ? /* @__PURE__ */ t(e, { children: n }) : /* @__PURE__ */ t("div", {
		class: "card m-6",
		children: /* @__PURE__ */ t(Y, {
			title: R("no_role_title"),
			text: R("no_role_text"),
			icon: "users"
		})
	});
}
//#endregion
//#region src/devtypes/types.ts
var cn = (e, t) => Object.entries(t).every(([t, n]) => e?.[t] === n);
function ln(e, t, n, r = {}) {
	return un(e, t, n, r)?.key;
}
function un(e, t, n, r = {}) {
	if (!e || !t) return;
	let i = (e) => Object.keys(e.qualifiers || {}).length - Object.keys(r).length;
	return (e.types[t] || []).filter((e) => e.role === n && cn(e.qualifiers, r)).reduce((e, t) => !e || i(t) < i(e) ? t : e, void 0);
}
function dn(e, t, n) {
	for (let [r, i] of n) {
		let n = un(e, t, r, i);
		if (n) return n;
	}
}
var fn = (e, t, n = {}) => !!e && Object.values(e.types).some((e) => e.some((e) => e.role === t && cn(e.qualifiers, n))), pn = (e, t) => e?.keys.find((e) => e.key === t), mn = (e) => {
	let t = (e.split(".").pop() || e).replace(/_/g, " ").trim();
	return t.charAt(0).toUpperCase() + t.slice(1);
}, hn = (e, t) => pn(e, t)?.label || mn(t), gn = {
	Cel: "°C",
	degC: "°C",
	"[degF]": "°F",
	"mA.h": "mAh",
	"A.h": "Ah",
	"km/h": "km/h",
	"m/s": "m/s",
	1: ""
}, _n = (e) => e ? gn[e] ?? e : "", vn = (e, t, n) => n?.key === t && n.unit_print !== void 0 ? n.unit_print : _n(pn(e, t)?.unit);
function yn(e, t, n) {
	let r = pn(e, t)?.enum;
	if (r) return r.find((e) => e.value === n || e.name === n);
}
var bn = (e) => (e?.keys || []).filter((e) => e.classes.includes("STATE") && !e.secret && !e.write_only), xn = (e) => (e?.commands || []).filter((e) => !e.hidden), Sn = o(null), Z = o(null), Cn = o({}), wn = (e, t = L.value) => `${t}:${e}`, Tn = null, En = "", Dn = /* @__PURE__ */ new Map();
function On() {
	return En !== L.value && (Tn = null), En = L.value, Tn ??= Promise.all([F.types(L.value), F.keyRoles()]).then(([e, t]) => {
		Sn.value = e.items || [], Z.value = t;
	}, (e) => {
		throw Tn = null, e;
	}), Tn;
}
function kn(e) {
	let t = L.value, n = wn(e, t);
	if (Cn.value[n]) return Promise.resolve(Cn.value[n]);
	let r = Dn.get(n);
	return r || (r = ve.typeDetail(e, void 0, t).then((e) => (Cn.value = {
		...Cn.value,
		[n]: e
	}, e), () => null).finally(() => Dn.delete(n)), Dn.set(n, r)), r;
}
function An(e) {
	if (!e) return null;
	let t = wn(e), n = Cn.value[t];
	return !n && !Dn.has(t) && kn(e), n ?? null;
}
function jn() {
	Tn = null, En = "", Dn.clear(), Sn.value = null, Z.value = null, Cn.value = {};
}
var Mn = (e, t, n) => (!Z.value && !Tn && On().catch(() => {}), ln(Z.value, e, t, n)), Nn = a(() => Sn.value?.length ?? 0);
//#endregion
//#region src/app/DebugPanel.tsx
function Pn() {
	s(() => void On().catch(() => {}), [L.value]);
	let r = (Sn.value || []).filter((e) => e.status === "active");
	return r.length ? /* @__PURE__ */ t("ul", {
		class: "text-sm space-y-1",
		"data-testid": "debug-types",
		children: r.map((r) => {
			let i = An(r.id), a = un(Z.value, r.id, "state_of_charge", { of: "battery" }), o = xn(i)[0];
			return /* @__PURE__ */ n("li", {
				"data-type": r.id,
				children: [
					/* @__PURE__ */ t("span", {
						class: "font-medium",
						children: r.name
					}),
					" ",
					/* @__PURE__ */ n("span", {
						class: "text-muted",
						children: [
							r.version,
							" · ",
							i ? `${i.keys.length} keys · lang ${i.lang || "?"}` : "…"
						]
					}),
					i && a && /* @__PURE__ */ n(e, { children: [" · ", /* @__PURE__ */ t("span", {
						"data-testid": "type-battery",
						children: hn(i, a.key)
					})] }),
					i && o && /* @__PURE__ */ n(e, { children: [" · ", /* @__PURE__ */ t("span", {
						"data-testid": "type-command",
						children: o.label
					})] })
				]
			}, r.id);
		})
	}) : null;
}
function Fn() {
	return /* @__PURE__ */ n("section", {
		class: "card max-w-4xl mx-auto my-6",
		"data-testid": "debug-panel",
		"aria-labelledby": "debug-title",
		children: [/* @__PURE__ */ n("div", {
			class: "card-h",
			children: [/* @__PURE__ */ t("span", {
				id: "debug-title",
				children: R("debug_title")
			}), /* @__PURE__ */ n("div", {
				class: "flex gap-2",
				children: [
					/* @__PURE__ */ t("select", {
						class: "btn btn-sm",
						"aria-label": R("language"),
						"data-testid": "debug-lang",
						value: L.value,
						onChange: (e) => ut(e.target.value),
						children: I.value.map((e) => /* @__PURE__ */ t("option", {
							value: e,
							children: Me(e)
						}, e))
					}),
					/* @__PURE__ */ t("select", {
						class: "btn btn-sm",
						"aria-label": R("scheme"),
						"data-testid": "debug-scheme",
						value: Pt.value || "auto",
						onChange: (e) => Jt(e.target.value),
						children: [
							"auto",
							"light",
							"dark"
						].map((e) => /* @__PURE__ */ t("option", {
							value: e,
							children: R("scheme_" + e)
						}, e))
					}),
					/* @__PURE__ */ t("button", {
						class: "btn btn-sm",
						onClick: () => se(),
						children: R("sign_out")
					})
				]
			})]
		}), /* @__PURE__ */ n("div", {
			class: "card-b space-y-4",
			children: [
				/* @__PURE__ */ t("p", {
					class: "text-sm text-muted",
					children: R("debug_text")
				}),
				/* @__PURE__ */ n("dl", {
					class: "kv",
					children: [
						/* @__PURE__ */ t("dt", { children: "tenant" }),
						/* @__PURE__ */ n("dd", {
							"data-testid": "debug-tenant",
							children: [
								z.value?.tenant,
								" (",
								z.value?.name,
								")"
							]
						}),
						/* @__PURE__ */ t("dt", { children: "principal" }),
						/* @__PURE__ */ n("dd", {
							"data-testid": "debug-principal",
							children: [
								Ze.value,
								" ",
								/* @__PURE__ */ t(q, {
									kind: "neutral",
									children: z.value?.kind
								})
							]
						}),
						/* @__PURE__ */ t("dt", { children: "api" }),
						/* @__PURE__ */ n("dd", { children: [
							D().api_base,
							" · v",
							String(z.value?.api_version ?? "").replace(/^v/, ""),
							" · schema ",
							z.value?.schema
						] }),
						/* @__PURE__ */ t("dt", { children: "theme" }),
						/* @__PURE__ */ t("dd", {
							"data-testid": "debug-theme",
							children: /* @__PURE__ */ n(q, {
								kind: "primary",
								children: [
									document.documentElement.dataset.gsPreset,
									" · ",
									Ft.value
								]
							})
						}),
						/* @__PURE__ */ t("dt", { children: "sign-in" }),
						/* @__PURE__ */ t("dd", { children: A() ? /* @__PURE__ */ t(q, {
							kind: "warn",
							children: R("dev_mode")
						}) : /* @__PURE__ */ t(q, {
							kind: "good",
							children: "Zitadel"
						}) })
					]
				}),
				/* @__PURE__ */ n("details", {
					open: !0,
					children: [/* @__PURE__ */ t("summary", {
						class: "text-sm font-semibold cursor-pointer",
						children: "/types"
					}), /* @__PURE__ */ t("div", {
						class: "mt-2",
						children: /* @__PURE__ */ t(Pn, {})
					})]
				}),
				/* @__PURE__ */ n("details", {
					open: !0,
					children: [/* @__PURE__ */ t("summary", {
						class: "text-sm font-semibold cursor-pointer",
						children: "/whoami"
					}), /* @__PURE__ */ t("pre", {
						class: "json text-xs mt-2",
						"data-testid": "debug-whoami",
						children: JSON.stringify(z.value, null, 2)
					})]
				}),
				/* @__PURE__ */ n("details", {
					open: !0,
					children: [/* @__PURE__ */ t("summary", {
						class: "text-sm font-semibold cursor-pointer",
						children: "/me"
					}), /* @__PURE__ */ t("pre", {
						class: "json text-xs mt-2",
						"data-testid": "debug-me",
						children: JSON.stringify(B.value, null, 2)
					})]
				})
			]
		})]
	});
}
//#endregion
//#region src/apiaccess/ApiAccess.tsx
var In = 864e5, Ln = 30, Rn = [
	"read",
	"config",
	"commands",
	"ui"
];
function zn(e) {
	if (e) return e;
	try {
		return new URL("/docs", new URL(D().api_base, typeof location > "u" ? "http://localhost/" : location.href)).href;
	} catch {
		return "/docs";
	}
}
function Bn(e, t = Date.now()) {
	if (e.revoked_at) return { kind: "revoked" };
	let n = e.expires_at ? Date.parse(e.expires_at) : NaN;
	if (n <= t) return { kind: "expired" };
	let r = Math.max(0, Math.ceil((n - t) / In));
	return e.overlap_until && Date.parse(e.overlap_until) > t ? {
		kind: "rotating",
		days: r
	} : r <= 30 ? {
		kind: "expiring",
		days: r
	} : {
		kind: "active",
		days: r
	};
}
function Vn(e) {
	let t = e.created_by;
	return t ? t.kind === "support" ? R("api_by_support") : t.kind === "override" ? R("api_by_security") : t.email || "–" : "–";
}
function Hn(e, t = Date.now()) {
	return new Date(t + Math.min(730, Math.max(1, Math.round(e))) * In).toISOString().replace(/\.\d{3}Z$/, "Z");
}
var Un = (e, t) => t || e || R("api_account_root");
function Wn({ docs: e }) {
	let [r] = S(), i = (e, n, i) => V(i) && /* @__PURE__ */ t(y, {
		href: e,
		"aria-current": r === e ? "page" : void 0,
		"data-testid": `api-tab-${e.split("/").pop()}`,
		class: `px-3 h-8 inline-flex items-center rounded-control text-sm no-underline ${r === e ? "bg-surface shadow-surface text-ink font-medium" : "text-ink-2 hover:text-ink"}`,
		children: n
	});
	return /* @__PURE__ */ n("div", {
		class: "flex flex-wrap items-center gap-1",
		children: [/* @__PURE__ */ n("nav", {
			class: "flex gap-1 grow",
			"aria-label": R("api_access"),
			children: [i("/settings/api", R("api_keys"), "api_keys:manage"), i("/settings/api/calls", R("api_calls"), "api_keys:manage|audit:read")]
		}), /* @__PURE__ */ n("a", {
			class: "btn btn-sm",
			href: zn(e),
			target: "_blank",
			rel: "noopener",
			"data-testid": "api-docs-link",
			children: [/* @__PURE__ */ t(K, { n: "link" }), R("api_docs")]
		})]
	});
}
function Gn({ children: e, docs: r, right: i }) {
	return /* @__PURE__ */ n("section", {
		class: "py-5 space-y-4",
		"aria-labelledby": "gs-api-title",
		children: [
			/* @__PURE__ */ n("div", {
				class: "flex flex-wrap items-end gap-x-8 gap-y-2",
				children: [/* @__PURE__ */ t("h1", {
					id: "gs-api-title",
					class: "text-[26px] font-semibold tracking-tight grow",
					children: R("api_access")
				}), i]
			}),
			/* @__PURE__ */ t(Wn, { docs: r }),
			e
		]
	});
}
function Kn({ k: e }) {
	let n = Bn(e);
	switch (n.kind) {
		case "revoked": return /* @__PURE__ */ t(q, {
			kind: "neutral",
			children: R("api_state_revoked")
		});
		case "expired": return /* @__PURE__ */ t(q, {
			kind: "crit",
			children: R("api_state_expired")
		});
		case "rotating": return /* @__PURE__ */ t(q, {
			kind: "warn",
			title: G.dt(e.overlap_until),
			children: R("api_state_rotating", n.days)
		});
		case "expiring": return /* @__PURE__ */ t(q, {
			kind: "warn",
			title: G.dt(e.expires_at),
			children: R("api_state_expiring", n.days)
		});
		default: return /* @__PURE__ */ t(q, {
			kind: "good",
			children: R("api_state_active")
		});
	}
}
function qn() {
	let [r, i] = u(!1), [a, o] = u(null), [c, l] = u(null), [d, f] = u(!1), [p, m] = u(null), [h, g] = u(null), _ = () => F.apiKeys(r).then((e) => {
		o(e), l(null);
	}, l);
	s(() => {
		_();
	}, [r]);
	let v = (a?.items.filter((e) => !e.revoked_at) || []).filter((e) => ["expired", "expiring"].includes(Bn(e).kind)), ee = (a?.grantable || []).some((e) => e.scopes.length > 0);
	return /* @__PURE__ */ t(Gn, {
		docs: a?.docs_url,
		right: a && /* @__PURE__ */ n("button", {
			class: "btn btn-primary",
			disabled: !ee,
			onClick: () => f(!0),
			"data-testid": "api-key-new",
			title: ee ? void 0 : R("api_cannot_create"),
			children: [/* @__PURE__ */ t(K, { n: "plus" }), R("api_key_new")]
		}),
		children: c ? /* @__PURE__ */ t(vt, { error: c }) : a ? /* @__PURE__ */ n(e, { children: [
			v.length > 0 && /* @__PURE__ */ n("div", {
				role: "status",
				class: "card p-3 flex items-center gap-2 text-sm bg-warn-soft text-warn",
				"data-testid": "api-expiry-warning",
				children: [/* @__PURE__ */ t(K, { n: "alert" }), R("api_expiry_warning", v.length)]
			}),
			/* @__PURE__ */ n("label", {
				class: "flex items-center gap-2 text-sm text-ink-2",
				children: [/* @__PURE__ */ t("input", {
					type: "checkbox",
					checked: r,
					onChange: (e) => i(e.target.checked),
					"data-testid": "api-show-revoked"
				}), R("api_show_revoked")]
			}),
			a.items.length === 0 ? /* @__PURE__ */ t(Y, {
				icon: "link",
				title: R("api_no_keys"),
				text: R("api_no_keys_text")
			}) : /* @__PURE__ */ t("div", {
				class: "relative overflow-x-auto -mx-4 px-4 lg:mx-0 lg:px-0",
				children: /* @__PURE__ */ n("table", {
					class: "tbl",
					"data-testid": "api-key-table",
					children: [/* @__PURE__ */ t("thead", { children: /* @__PURE__ */ n("tr", { children: [
						/* @__PURE__ */ t("th", { children: R("col_name") }),
						/* @__PURE__ */ t("th", { children: R("api_scopes") }),
						/* @__PURE__ */ t("th", { children: R("api_account") }),
						/* @__PURE__ */ t("th", { children: R("api_rate") }),
						/* @__PURE__ */ t("th", { children: R("api_created") }),
						/* @__PURE__ */ t("th", { children: R("api_last_used") }),
						/* @__PURE__ */ t("th", { children: R("api_expires") }),
						/* @__PURE__ */ t("th", { children: /* @__PURE__ */ t("span", {
							class: "sr-only",
							children: R("api_actions")
						}) })
					] }) }), /* @__PURE__ */ t("tbody", { children: a.items.map((e) => /* @__PURE__ */ n("tr", {
						"data-key-id": e.id,
						class: e.revoked_at ? "text-muted" : void 0,
						children: [
							/* @__PURE__ */ n("td", {
								class: "min-w-[8rem]",
								children: [/* @__PURE__ */ t("div", {
									class: "font-medium",
									children: e.name
								}), /* @__PURE__ */ n("div", {
									class: "font-mono text-[12px] text-muted",
									children: [e.prefix, "…"]
								})]
							}),
							/* @__PURE__ */ t("td", { children: /* @__PURE__ */ t("div", {
								class: "flex flex-wrap gap-1",
								children: e.scopes.map((e) => /* @__PURE__ */ t(q, {
									kind: "primary",
									children: R("api_scope_" + e)
								}, e))
							}) }),
							/* @__PURE__ */ t("td", {
								class: "text-ink-2",
								children: Un(e.account_id, e.account_name)
							}),
							/* @__PURE__ */ n("td", {
								class: "tabular-nums whitespace-nowrap",
								children: [
									R("api_rate_min", G.num(e.rate_per_min)),
									/* @__PURE__ */ t("div", {
										class: "text-xs text-muted",
										children: R("api_burst_value", G.num(e.burst))
									}),
									e.daily_quota !== null && /* @__PURE__ */ t("div", {
										class: "text-xs text-muted",
										children: R("api_quota_value", G.num(e.daily_quota))
									})
								]
							}),
							/* @__PURE__ */ n("td", { children: [/* @__PURE__ */ t("div", {
								class: "whitespace-nowrap",
								title: G.dt(e.created_at),
								children: G.ago(e.created_at)
							}), /* @__PURE__ */ t("div", {
								class: "text-xs text-muted max-w-[9rem] truncate",
								title: Vn(e),
								children: Vn(e)
							})] }),
							/* @__PURE__ */ t("td", {
								class: "whitespace-nowrap",
								title: G.dt(e.last_used_at),
								children: e.last_used_at ? G.ago(e.last_used_at) : R("never")
							}),
							/* @__PURE__ */ n("td", {
								class: "whitespace-nowrap",
								children: [/* @__PURE__ */ t(Kn, { k: e }), e.expires_at && /* @__PURE__ */ t("div", {
									class: "text-xs text-muted mt-0.5",
									title: G.dt(e.expires_at),
									children: G.day(e.expires_at)
								})]
							}),
							/* @__PURE__ */ t("td", {
								class: "whitespace-nowrap text-right",
								children: !e.revoked_at && Bn(e).kind !== "expired" && /* @__PURE__ */ n("span", {
									class: "inline-flex gap-1",
									children: [Bn(e).kind !== "rotating" && /* @__PURE__ */ t("button", {
										class: "btn btn-sm",
										onClick: () => g({
											k: e,
											what: "rotate"
										}),
										children: R("api_rotate")
									}), /* @__PURE__ */ t("button", {
										class: "btn btn-sm",
										onClick: () => g({
											k: e,
											what: "revoke"
										}),
										children: R("api_revoke")
									})]
								})
							})
						]
					}, e.id)) })]
				})
			}),
			/* @__PURE__ */ t(yt, {
				open: d,
				title: R("api_key_new"),
				onClose: () => f(!1),
				children: /* @__PURE__ */ t(Qn, {
					list: a,
					onDone: (e) => {
						f(!1), m(e), _();
					}
				})
			}),
			/* @__PURE__ */ t(yt, {
				open: !!h,
				title: h ? R(h.what === "rotate" ? "api_rotate_title" : "api_revoke_title", h.k.name) : "",
				onClose: () => g(null),
				children: h && /* @__PURE__ */ t(Xn, {
					k: h.k,
					what: h.what,
					onDone: (e) => {
						g(null), e && m(e), _();
					}
				})
			}),
			/* @__PURE__ */ t(yt, {
				open: !!p,
				title: R("api_secret_title"),
				onClose: () => m(null),
				children: p && /* @__PURE__ */ t(Zn, {
					s: p,
					onClose: () => m(null)
				})
			})
		] }) : /* @__PURE__ */ t(J, {})
	});
}
var Jn = () => typeof crypto < "u" && crypto.randomUUID ? crypto.randomUUID() : `${Date.now()}-${Math.random()}`, Yn = (e, t) => {
	t instanceof j && (e.current = Jn());
};
function Xn({ k: e, what: r, onDone: i }) {
	let [a, o] = u(!1), [s, c] = u(""), d = l(Jn());
	return /* @__PURE__ */ n("div", {
		class: "space-y-4",
		children: [
			/* @__PURE__ */ t("p", {
				class: "text-sm",
				children: R(r === "rotate" ? "api_rotate_text" : "api_revoke_text")
			}),
			s && /* @__PURE__ */ t("p", {
				class: "text-sm text-crit",
				role: "alert",
				children: s
			}),
			/* @__PURE__ */ t("div", {
				class: "flex justify-end gap-2",
				children: /* @__PURE__ */ t("button", {
					class: r === "revoke" ? "btn btn-danger" : "btn btn-primary",
					disabled: a,
					onClick: () => {
						o(!0), (r === "rotate" ? F.rotateApiKey(e.id, d.current) : F.revokeApiKey(e.id).then(() => void 0)).then((e) => i(e || void 0), (e) => {
							Yn(d, e), c(bt(e).message), o(!1);
						});
					},
					"data-testid": "api-confirm",
					children: R(r === "rotate" ? "api_rotate" : "api_revoke")
				})
			})
		]
	});
}
function Zn({ s: e, onClose: r }) {
	let [i, a] = u(!1);
	return /* @__PURE__ */ n("div", {
		class: "space-y-4",
		children: [
			/* @__PURE__ */ t("p", {
				class: "text-sm",
				children: R("api_secret_once", e.key.name)
			}),
			/* @__PURE__ */ n("div", {
				class: "flex gap-2 items-stretch",
				children: [/* @__PURE__ */ t("input", {
					class: "field font-mono text-[12.5px]",
					readOnly: !0,
					value: e.secret,
					"aria-label": R("api_secret"),
					"data-testid": "api-secret",
					onFocus: (e) => e.target.select()
				}), /* @__PURE__ */ t("button", {
					class: "btn",
					onClick: () => navigator.clipboard?.writeText(e.secret).then(() => a(!0), () => a(!1)),
					"data-testid": "api-copy",
					children: R(i ? "api_copied" : "api_copy")
				})]
			}),
			/* @__PURE__ */ t("div", {
				class: "flex justify-end",
				children: /* @__PURE__ */ t("button", {
					class: "btn btn-primary",
					onClick: r,
					children: R("api_secret_done")
				})
			})
		]
	});
}
function Qn({ list: e, onDone: r }) {
	let i = e.grantable.filter((e) => e.scopes.length > 0), a = e.limits, [o, d] = u(""), [f, p] = u(0), m = i[f], [h, g] = u(m?.scopes.includes("read") ? ["read"] : []), _ = l(Jn()), [v, ee] = u(a.rate_per_min_default), [y, b] = u(a.burst_default), [x, S] = u(""), [C, w] = u(365), [te, T] = u(!1), [E, ne] = u(null);
	s(() => g((e) => e.filter((e) => m?.scopes.includes(e))), [f]);
	let D = c(() => {
		let e = {};
		return o.trim() || (e.name = R("api_err_name")), h.length || (e.scopes = R("api_err_scopes")), v >= 1 && v <= a.rate_per_min_max || (e.rate_per_min = R("api_err_range", 1, G.num(a.rate_per_min_max))), y >= 1 || (e.burst = R("api_err_range", 1, "∞")), x && !(+x >= 1 && (a.daily_quota_max === null || +x <= a.daily_quota_max)) && (e.daily_quota = R("api_err_range", 1, a.daily_quota_max === null ? "∞" : G.num(a.daily_quota_max))), C >= 1 && C <= 730 || (e.expires_at = R("api_err_range", 1, 730)), e;
	}, [
		o,
		h,
		v,
		y,
		x,
		C
	]), O = (e) => {
		e.preventDefault(), !Object.keys(D).length && m && (T(!0), F.createApiKey({
			name: o.trim(),
			scopes: h,
			account_id: m.account_id,
			rate_per_min: v,
			burst: y,
			daily_quota: x ? +x : null,
			expires_at: Hn(C)
		}, _.current).then(r, (e) => {
			Yn(_, e), ne(bt(e)), T(!1);
		}));
	}, k = (e) => (E?.fields[e] || D[e]) && /* @__PURE__ */ t("span", {
		class: "text-xs text-crit",
		children: E?.fields[e] || D[e]
	}), A = !!E;
	return /* @__PURE__ */ n("form", {
		class: "space-y-4",
		onSubmit: O,
		"data-testid": "api-key-form",
		noValidate: !0,
		children: [
			/* @__PURE__ */ n("label", {
				class: "block space-y-1",
				children: [
					/* @__PURE__ */ t("span", {
						class: "text-sm font-medium",
						children: R("col_name")
					}),
					/* @__PURE__ */ t("input", {
						class: "field",
						value: o,
						maxLength: 100,
						required: !0,
						onInput: (e) => d(e.target.value),
						"data-testid": "api-key-name"
					}),
					A && k("name")
				]
			}),
			i.length > 1 && /* @__PURE__ */ n("label", {
				class: "block space-y-1",
				children: [
					/* @__PURE__ */ t("span", {
						class: "text-sm font-medium",
						children: R("api_account")
					}),
					/* @__PURE__ */ t("select", {
						class: "field",
						value: f,
						onChange: (e) => p(+e.target.value),
						"data-testid": "api-key-account",
						children: i.map((e, n) => /* @__PURE__ */ t("option", {
							value: n,
							children: Un(e.account_id, e.account_name)
						}, e.account_id ?? "root"))
					}),
					/* @__PURE__ */ t("span", {
						class: "text-xs text-muted",
						children: R("api_account_hint")
					})
				]
			}),
			i.length === 1 && m && /* @__PURE__ */ n("p", {
				class: "text-sm text-ink-2",
				children: [
					R("api_account"),
					": ",
					Un(m.account_id, m.account_name)
				]
			}),
			/* @__PURE__ */ n("fieldset", {
				class: "space-y-1",
				children: [
					/* @__PURE__ */ t("legend", {
						class: "text-sm font-medium",
						children: R("api_scopes")
					}),
					Rn.filter((e) => m?.scopes.includes(e)).map((e) => /* @__PURE__ */ n("label", {
						class: "flex items-start gap-2 text-sm",
						children: [/* @__PURE__ */ t("input", {
							type: "checkbox",
							class: "mt-0.5",
							checked: h.includes(e),
							"data-testid": `api-scope-${e}`,
							onChange: (t) => g((n) => t.target.checked ? [...n, e] : n.filter((t) => t !== e))
						}), /* @__PURE__ */ n("span", { children: [
							/* @__PURE__ */ t("span", {
								class: "font-medium",
								children: R("api_scope_" + e)
							}),
							" ",
							/* @__PURE__ */ t("span", {
								class: "text-muted",
								children: R("api_scope_" + e + "_text")
							})
						] })]
					}, e)),
					A && k("scopes")
				]
			}),
			/* @__PURE__ */ n("div", {
				class: "grid grid-cols-1 sm:grid-cols-2 gap-3",
				children: [
					/* @__PURE__ */ n("label", {
						class: "block space-y-1",
						children: [
							/* @__PURE__ */ t("span", {
								class: "text-sm font-medium",
								children: R("api_rate_per_min")
							}),
							/* @__PURE__ */ t("input", {
								class: "field",
								type: "number",
								min: 1,
								max: a.rate_per_min_max,
								value: v,
								onInput: (e) => ee(+e.target.value),
								"data-testid": "api-key-rate"
							}),
							/* @__PURE__ */ t("span", {
								class: "text-xs text-muted",
								children: R("api_rate_max", G.num(a.rate_per_min_max))
							}),
							A && k("rate_per_min")
						]
					}),
					/* @__PURE__ */ n("label", {
						class: "block space-y-1",
						children: [
							/* @__PURE__ */ t("span", {
								class: "text-sm font-medium",
								children: R("api_burst")
							}),
							/* @__PURE__ */ t("input", {
								class: "field",
								type: "number",
								min: 1,
								value: y,
								onInput: (e) => b(+e.target.value),
								"data-testid": "api-key-burst"
							}),
							A && k("burst")
						]
					}),
					/* @__PURE__ */ n("label", {
						class: "block space-y-1",
						children: [
							/* @__PURE__ */ t("span", {
								class: "text-sm font-medium",
								children: R("api_daily_quota")
							}),
							/* @__PURE__ */ t("input", {
								class: "field",
								type: "number",
								min: 1,
								placeholder: R("api_quota_none"),
								value: x,
								onInput: (e) => S(e.target.value),
								"data-testid": "api-key-quota"
							}),
							A && k("daily_quota")
						]
					}),
					/* @__PURE__ */ n("label", {
						class: "block space-y-1",
						children: [
							/* @__PURE__ */ t("span", {
								class: "text-sm font-medium",
								children: R("api_valid_days")
							}),
							/* @__PURE__ */ t("input", {
								class: "field",
								type: "number",
								min: 1,
								max: 730,
								value: C,
								onInput: (e) => w(+e.target.value),
								"data-testid": "api-key-days"
							}),
							/* @__PURE__ */ t("span", {
								class: "text-xs text-muted",
								children: R("api_valid_until", G.dt(Hn(C >= 1 ? C : 1)))
							}),
							A && k("expires_at")
						]
					})
				]
			}),
			E && /* @__PURE__ */ t("p", {
				class: "text-sm text-crit",
				role: "alert",
				"data-testid": "api-key-error",
				children: E.message
			}),
			/* @__PURE__ */ t("div", {
				class: "flex justify-end",
				children: /* @__PURE__ */ t("button", {
					class: "btn btn-primary",
					type: "submit",
					disabled: te,
					onClick: () => Object.keys(D).length && ne({
						message: R("api_err_form"),
						fields: {}
					}),
					"data-testid": "api-key-create",
					children: R("api_create")
				})
			})
		]
	});
}
var $n = [
	["1h", 1],
	["24h", 24],
	["7d", 168],
	["30d", 720],
	["90d", 2160]
], er = [
	"2xx",
	"4xx",
	"429",
	"5xx"
];
function tr(e) {
	return e < 300 ? "good" : e === 429 || e < 500 ? "warn" : "crit";
}
function nr(e) {
	return e < 1024 ? `${G.num(e)} B` : e < 1048576 ? `${G.dec(e / 1024, 1)} kB` : `${G.dec(e / 1024 / 1024, 1)} MB`;
}
var rr = (e) => `${e < 10 ? G.dec(e, 1) : G.num(Math.round(e))} ms`;
function ir(e) {
	let t = /* @__PURE__ */ new Map();
	for (let n of e) {
		let e = t.get(n.key_id) || {
			key_id: n.key_id,
			key_name: n.key_name,
			calls: 0,
			errors: 0,
			throttled: 0
		};
		e.calls += n.calls, e.errors += n.errors, e.throttled += n.throttled, t.set(n.key_id, e);
	}
	return [...t.values()].sort((e, t) => t.calls - e.calls);
}
function ar() {
	let [r, i] = u("24h"), [a, o] = u(""), [l, d] = u(""), [f, p] = u(""), [m, h] = u(""), [g, _] = u([]), [v, ee] = u(), [y, b] = u(null), [x, S] = u(null), C = c(() => (/* @__PURE__ */ new Date(Date.now() - ($n.find((e) => e[0] === r)?.[1] || 24) * 36e5)).toISOString().replace(/\.\d{3}Z$/, "Z"), [r]);
	s(() => {
		let e = setTimeout(() => h(f.trim()), 300);
		return () => clearTimeout(e);
	}, [f]), s(() => {
		V("api_keys:manage") && F.apiKeys(!0).then((e) => {
			_(e.items), ee(e.docs_url);
		}, () => _([]));
	}, []), s(() => {
		b(null), F.apiCallTotals({
			from: C,
			key_id: a || void 0
		}).then((e) => b(e.items || []), () => b([]));
	}, [C, a]);
	let w = Dt((e) => F.apiCalls({
		key_id: a || void 0,
		status: l || void 0,
		path: m || void 0,
		from: C,
		before: e,
		limit: 50
	}), [
		a,
		l,
		m,
		C
	]), te = c(() => {
		let e = /* @__PURE__ */ new Map();
		for (let t of g) e.set(t.id, `${t.name} (${t.prefix}…)`);
		for (let t of y || []) e.has(t.key_id) || e.set(t.key_id, t.key_name || R("api_key_gone"));
		return [...e.entries()];
	}, [g, y]), T = c(() => ir(y || []), [y]), E = c(() => [...new Set((y || []).map((e) => e.day))].sort().reverse(), [y]);
	return /* @__PURE__ */ n(Gn, {
		docs: v,
		children: [
			/* @__PURE__ */ n("div", {
				class: "flex flex-wrap gap-2 items-center",
				"data-testid": "api-call-filters",
				children: [
					/* @__PURE__ */ t("label", {
						class: "sr-only",
						for: "gs-api-range",
						children: R("api_range")
					}),
					/* @__PURE__ */ t("select", {
						id: "gs-api-range",
						class: "field w-auto",
						value: r,
						onChange: (e) => i(e.target.value),
						"data-testid": "api-filter-range",
						children: $n.map(([e]) => /* @__PURE__ */ t("option", {
							value: e,
							children: R("api_range_" + e)
						}, e))
					}),
					/* @__PURE__ */ t("label", {
						class: "sr-only",
						for: "gs-api-key",
						children: R("api_key")
					}),
					/* @__PURE__ */ n("select", {
						id: "gs-api-key",
						class: "field w-auto",
						value: a,
						onChange: (e) => o(e.target.value),
						"data-testid": "api-filter-key",
						children: [/* @__PURE__ */ t("option", {
							value: "",
							children: R("api_all_keys")
						}), te.map(([e, n]) => /* @__PURE__ */ t("option", {
							value: e,
							children: n
						}, e))]
					}),
					/* @__PURE__ */ t("label", {
						class: "sr-only",
						for: "gs-api-status",
						children: R("api_status")
					}),
					/* @__PURE__ */ n("select", {
						id: "gs-api-status",
						class: "field w-auto",
						value: l,
						onChange: (e) => d(e.target.value),
						"data-testid": "api-filter-status",
						children: [/* @__PURE__ */ t("option", {
							value: "",
							children: R("api_all_statuses")
						}), er.map((e) => /* @__PURE__ */ t("option", {
							value: e,
							children: R("api_status_" + e)
						}, e))]
					}),
					/* @__PURE__ */ n("label", {
						class: "relative grow min-w-[12rem] max-w-md",
						children: [
							/* @__PURE__ */ t("span", {
								class: "sr-only",
								children: R("api_path")
							}),
							/* @__PURE__ */ t(K, {
								n: "search",
								class: "size-4 text-muted absolute left-3 top-1/2 -translate-y-1/2"
							}),
							/* @__PURE__ */ t("input", {
								class: "field pl-9",
								type: "search",
								placeholder: R("api_path_placeholder"),
								value: f,
								"data-testid": "api-filter-path",
								onInput: (e) => p(e.target.value)
							})
						]
					})
				]
			}),
			/* @__PURE__ */ n("div", {
				class: "card p-4 space-y-3",
				"data-testid": "api-totals",
				children: [/* @__PURE__ */ t("div", {
					class: "text-sm font-medium",
					children: R("api_totals")
				}), y ? T.length === 0 ? /* @__PURE__ */ t("p", {
					class: "text-sm text-muted",
					children: R("api_no_calls")
				}) : /* @__PURE__ */ t("div", {
					class: "relative overflow-x-auto",
					children: /* @__PURE__ */ n("table", {
						class: "tbl",
						children: [/* @__PURE__ */ t("thead", { children: /* @__PURE__ */ n("tr", { children: [
							/* @__PURE__ */ t("th", { children: R("api_key") }),
							E.map((e) => /* @__PURE__ */ n("th", {
								class: "text-right",
								children: [
									G.num(+e.slice(8, 10)),
									".",
									e.slice(5, 7),
									"."
								]
							}, e)),
							/* @__PURE__ */ t("th", {
								class: "text-right",
								children: R("api_total")
							}),
							/* @__PURE__ */ t("th", {
								class: "text-right",
								children: R("api_errors")
							}),
							/* @__PURE__ */ t("th", {
								class: "text-right",
								children: R("api_throttled")
							})
						] }) }), /* @__PURE__ */ t("tbody", { children: T.map((e) => /* @__PURE__ */ n("tr", {
							"data-key-id": e.key_id,
							children: [
								/* @__PURE__ */ t("td", {
									class: "font-medium",
									children: e.key_name || R("api_key_gone")
								}),
								E.map((n) => /* @__PURE__ */ t("td", {
									class: "text-right tabular-nums",
									children: G.num((y || []).find((t) => t.key_id === e.key_id && t.day === n)?.calls ?? 0)
								}, n)),
								/* @__PURE__ */ t("td", {
									class: "text-right tabular-nums font-medium",
									"data-testid": "api-total-calls",
									children: G.num(e.calls)
								}),
								/* @__PURE__ */ t("td", {
									class: "text-right tabular-nums",
									children: G.num(e.errors)
								}),
								/* @__PURE__ */ t("td", {
									class: "text-right tabular-nums",
									children: G.num(e.throttled)
								})
							]
						}, e.key_id)) })]
					})
				}) : /* @__PURE__ */ t(J, {})]
			}),
			w.error ? /* @__PURE__ */ t(vt, { error: w.error }) : w.data ? w.data.items.length === 0 ? /* @__PURE__ */ t(Y, {
				icon: "history",
				title: R("api_no_calls"),
				text: R("api_no_calls_text")
			}) : /* @__PURE__ */ n(e, { children: [/* @__PURE__ */ t("div", {
				class: "relative overflow-x-auto -mx-4 px-4 lg:mx-0 lg:px-0",
				children: /* @__PURE__ */ n("table", {
					class: "tbl",
					"data-testid": "api-call-table",
					children: [/* @__PURE__ */ t("thead", { children: /* @__PURE__ */ n("tr", { children: [
						/* @__PURE__ */ t("th", { children: R("api_time") }),
						/* @__PURE__ */ t("th", { children: R("api_key") }),
						/* @__PURE__ */ t("th", { children: R("api_request") }),
						/* @__PURE__ */ t("th", { children: R("api_status") }),
						/* @__PURE__ */ t("th", {
							class: "text-right",
							children: R("api_duration")
						}),
						/* @__PURE__ */ t("th", {
							class: "text-right",
							children: R("api_bytes")
						})
					] }) }), /* @__PURE__ */ t("tbody", { children: w.data.items.map((e) => /* @__PURE__ */ n("tr", {
						"data-call-id": e.id,
						class: "cursor-pointer",
						onClick: () => S(e),
						children: [
							/* @__PURE__ */ t("td", {
								class: "whitespace-nowrap",
								title: e.at,
								children: G.dt(e.at)
							}),
							/* @__PURE__ */ t("td", { children: or(e) }),
							/* @__PURE__ */ t("td", {
								class: "font-mono text-[12.5px]",
								children: /* @__PURE__ */ n("button", {
									type: "button",
									class: "text-left hover:underline",
									onClick: (t) => {
										t.stopPropagation(), S(e);
									},
									children: [
										/* @__PURE__ */ t("span", {
											class: "text-muted",
											children: e.method
										}),
										" ",
										e.path
									]
								})
							}),
							/* @__PURE__ */ t("td", { children: /* @__PURE__ */ t(q, {
								kind: tr(e.status),
								children: e.status
							}) }),
							/* @__PURE__ */ t("td", {
								class: "text-right tabular-nums",
								children: rr(e.duration_ms)
							}),
							/* @__PURE__ */ t("td", {
								class: "text-right tabular-nums",
								children: nr(e.bytes_in + e.bytes_out)
							})
						]
					}, e.id)) })]
				})
			}), /* @__PURE__ */ t(Ot, { ...w.pager })] }) : /* @__PURE__ */ t(J, {}),
			/* @__PURE__ */ t(yt, {
				open: !!x,
				title: R("api_call_detail"),
				onClose: () => S(null),
				wide: !0,
				children: x && /* @__PURE__ */ t(sr, { row: x })
			})
		]
	});
}
var or = (e) => e.key_name || `${e.key_prefix}…`;
function sr({ row: r }) {
	let [i, a] = u(r);
	s(() => {
		F.apiCall(r.id).then(a, () => void 0);
	}, [r.id]);
	let o = [
		[R("api_time"), G.dt(i.at)],
		[R("api_key"), i.key_name ? `${i.key_name} (${i.key_prefix}…)` : `${i.key_prefix}… · ${R("api_key_gone")}`],
		[R("api_request"), /* @__PURE__ */ n("span", {
			class: "font-mono text-[12.5px] break-all",
			children: [
				i.method,
				" ",
				i.path,
				i.query ? `?${i.query}` : ""
			]
		})],
		[R("api_status"), /* @__PURE__ */ t(q, {
			kind: tr(i.status),
			children: i.status
		})],
		[R("api_error_code"), i.error_code || "–"],
		[R("api_duration"), rr(i.duration_ms)],
		[R("api_bytes_in"), nr(i.bytes_in)],
		[R("api_bytes_out"), nr(i.bytes_out)],
		[R("api_client_ip"), i.client_ip || "–"],
		[R("api_user_agent"), i.user_agent || "–"],
		[R("api_request_id"), i.request_id ? /* @__PURE__ */ t("span", {
			class: "font-mono text-[12.5px]",
			children: i.request_id
		}) : "–"]
	];
	return /* @__PURE__ */ t("dl", {
		class: "grid grid-cols-[minmax(8rem,auto)_1fr] gap-x-4 gap-y-2 text-sm",
		"data-testid": "api-call-detail",
		children: o.map(([r, i]) => /* @__PURE__ */ n(e, { children: [/* @__PURE__ */ t("dt", {
			class: "text-muted",
			children: r
		}), /* @__PURE__ */ t("dd", {
			class: "min-w-0",
			children: i
		})] }))
	});
}
var cr = {
	id: "api",
	routes: [{
		path: "/settings/api",
		component: qn,
		perm: "api_keys:manage"
	}, {
		path: "/settings/api/calls",
		component: ar,
		perm: "api_keys:manage|audit:read"
	}],
	menu: {
		label: "api_access",
		icon: "key",
		route: "/settings/api",
		perm: "api_keys:manage",
		group: "settings"
	}
}, lr = [
	25,
	50,
	100,
	200,
	500
], ur = [
	["state_of_charge", { of: "battery" }],
	["voltage", { of: "battery" }],
	["battery_low"]
];
function dr(e, t = Date.now()) {
	if (!e) return "warn";
	let n = (t - Date.parse(e)) / 36e5;
	return n <= 24 ? "good" : n <= 168 ? "neutral" : "warn";
}
var fr = {
	good: "bg-good",
	neutral: "bg-neutral",
	warn: "bg-warn"
};
function pr({ d: e, role: r }) {
	if (!r) return /* @__PURE__ */ t("span", {
		class: "text-muted",
		children: "–"
	});
	let i = mt(e.state, r.key);
	if (i == null) return /* @__PURE__ */ t("span", {
		class: "text-muted",
		children: "–"
	});
	if (r.role === "battery_low") return i ? /* @__PURE__ */ t("span", {
		class: "chip chip-warn",
		children: R("battery_low")
	}) : /* @__PURE__ */ t("span", {
		class: "chip chip-good",
		children: R("battery_ok")
	});
	let a = r.unit_print ?? _n(r.unit);
	return /* @__PURE__ */ n("span", {
		class: "tabular-nums",
		children: [typeof i == "number" ? G.num(i) : String(i), a && /* @__PURE__ */ n("span", {
			class: "text-muted",
			children: [" ", a]
		})]
	});
}
function mr(e, t = 300) {
	let [n, r] = u(e);
	return s(() => {
		let n = setTimeout(() => r(e), t);
		return () => clearTimeout(n);
	}, [e, t]), n;
}
function hr() {
	let [r, i] = u(""), a = mr(r), [o, d] = u(""), [f, p] = u(""), { page: m, size: h, setPage: g, setSize: _ } = wt("devices", 50), [v, ee] = u(null), [b, x] = u(null), [S, C] = u([]), [w, te] = u([]), T = l(0), [E, ne] = u(!1);
	s(() => {
		On().then(() => ne(!0), () => ne(!0)), F.propertyDefs().then((e) => C((e.items || []).filter((e) => e.groupable)), () => C([]));
	}, []), s(() => {
		if (p(""), !o) return te([]);
		F.labelValues(o).then((e) => te(e.items || []), () => te([]));
	}, [o]);
	let D = Z.value, O = c(() => {
		let e = /* @__PURE__ */ new Set();
		for (let t of Object.keys(D?.types || {})) {
			let n = dn(D, t, ur);
			n && e.add(n.key);
		}
		return [...e].slice(0, 40);
	}, [D]), k = () => {
		if (!E) return;
		let e = ++T.current;
		F.fleetDevices({
			q: a.trim() || void 0,
			labels: o && f ? { [o]: f } : void 0,
			keys: O,
			sort: "name",
			dir: "asc",
			page: m,
			page_size: h
		}).then((t) => {
			e === T.current && (ee(t), x(null));
		}, (t) => e === T.current && x(t));
	};
	s(k, [
		E,
		a,
		o,
		f,
		m,
		h,
		O.join(",")
	]), s(() => g(1), [
		a,
		o,
		f
	]), nt(c(() => v?.items.map((e) => e.device_id) || [], [v]), () => k());
	let A = !!(a.trim() || o && f);
	return /* @__PURE__ */ n("section", {
		class: "py-5 space-y-4",
		"data-testid": "device-list",
		"aria-labelledby": "gs-devices-title",
		children: [
			/* @__PURE__ */ n("div", {
				class: "flex flex-wrap items-end gap-x-8 gap-y-2",
				children: [/* @__PURE__ */ t("h1", {
					id: "gs-devices-title",
					class: "text-[26px] font-semibold tracking-tight grow",
					children: R("devices")
				}), v && /* @__PURE__ */ t("span", {
					class: "text-sm text-muted",
					"data-testid": "device-count",
					children: R("devices_n", v.total)
				})]
			}),
			/* @__PURE__ */ n("div", {
				class: "flex flex-wrap gap-2 items-center",
				children: [/* @__PURE__ */ n("label", {
					class: "relative grow min-w-[12rem] max-w-md",
					children: [
						/* @__PURE__ */ t("span", {
							class: "sr-only",
							children: R("search_devices")
						}),
						/* @__PURE__ */ t(K, {
							n: "search",
							class: "size-4 text-muted absolute left-3 top-1/2 -translate-y-1/2"
						}),
						/* @__PURE__ */ t("input", {
							class: "field pl-9",
							type: "search",
							placeholder: R("search_devices"),
							value: r,
							"data-testid": "device-search",
							onInput: (e) => i(e.target.value)
						})
					]
				}), S.length > 0 && /* @__PURE__ */ n(e, { children: [
					/* @__PURE__ */ t("label", {
						class: "sr-only",
						for: "gs-label-key",
						children: R("label_filter")
					}),
					/* @__PURE__ */ n("select", {
						id: "gs-label-key",
						class: "field w-auto",
						value: o,
						"data-testid": "label-key",
						onChange: (e) => d(e.target.value),
						children: [/* @__PURE__ */ t("option", {
							value: "",
							children: R("label_filter")
						}), S.map((e) => /* @__PURE__ */ t("option", {
							value: e.key,
							children: e.label || e.key
						}, e.key))]
					}),
					o && /* @__PURE__ */ n(e, { children: [/* @__PURE__ */ t("label", {
						class: "sr-only",
						for: "gs-label-value",
						children: R("label_value")
					}), /* @__PURE__ */ n("select", {
						id: "gs-label-value",
						class: "field w-auto",
						value: f,
						"data-testid": "label-value",
						onChange: (e) => p(e.target.value),
						children: [/* @__PURE__ */ t("option", {
							value: "",
							children: R("label_any")
						}), w.map((e) => /* @__PURE__ */ t("option", {
							value: e.value,
							children: e.display_name || e.value
						}, e.value))]
					})] })
				] })]
			}),
			b ? /* @__PURE__ */ t(vt, { error: b }) : v ? v.items.length === 0 ? A ? /* @__PURE__ */ t(Y, { title: R("no_device_match") }) : /* @__PURE__ */ t(Y, {
				icon: "box",
				title: R("no_devices_title"),
				text: R("no_devices_text")
			}) : /* @__PURE__ */ n(e, { children: [/* @__PURE__ */ t("div", {
				class: "overflow-x-auto -mx-4 px-4 lg:mx-0 lg:px-0",
				children: /* @__PURE__ */ n("table", {
					class: "tbl",
					"data-testid": "device-table",
					children: [/* @__PURE__ */ t("thead", { children: /* @__PURE__ */ n("tr", { children: [
						/* @__PURE__ */ t("th", {
							class: "w-6",
							children: /* @__PURE__ */ t("span", {
								class: "sr-only",
								children: R("col_contact")
							})
						}),
						/* @__PURE__ */ t("th", { children: R("col_name") }),
						/* @__PURE__ */ t("th", { children: R("col_serial") }),
						/* @__PURE__ */ t("th", { children: R("col_type") }),
						/* @__PURE__ */ t("th", { children: R("col_battery") }),
						/* @__PURE__ */ t("th", { children: R("col_last_seen") })
					] }) }), /* @__PURE__ */ t("tbody", { children: v.items.map((e) => {
						let r = dr(e.last_contact_utc);
						return /* @__PURE__ */ n("tr", {
							"data-device-id": e.device_id,
							children: [
								/* @__PURE__ */ t("td", { children: /* @__PURE__ */ t("span", {
									class: `dot ${fr[r]}`,
									title: R("contact_" + r),
									role: "img",
									"aria-label": R("contact_" + r)
								}) }),
								/* @__PURE__ */ t("td", {
									class: "font-medium",
									children: /* @__PURE__ */ t(y, {
										href: `/devices/${encodeURIComponent(e.device_id)}`,
										class: "text-ink no-underline hover:underline",
										children: ue(e)
									})
								}),
								/* @__PURE__ */ t("td", {
									class: "font-mono text-[12.5px] text-muted",
									children: de(e)
								}),
								/* @__PURE__ */ t("td", {
									class: "text-ink-2",
									children: e.type_name || e.type_id
								}),
								/* @__PURE__ */ t("td", { children: /* @__PURE__ */ t(pr, {
									d: e,
									role: dn(D, e.type_id, ur)
								}) }),
								/* @__PURE__ */ t("td", {
									class: "text-ink-2 whitespace-nowrap",
									title: G.dt(e.last_contact_utc),
									children: e.last_contact_utc ? G.ago(e.last_contact_utc) : R("never")
								})
							]
						}, e.device_id);
					}) })]
				})
			}), /* @__PURE__ */ t(Et, {
				page: m,
				size: h,
				total: v.total,
				onPage: g,
				onSize: _,
				sizes: lr
			})] }) : /* @__PURE__ */ t(J, {})
		]
	});
}
var gr = {
	id: "devices",
	routes: [{
		path: "/devices",
		component: hr,
		perm: "devices:read"
	}],
	menu: {
		label: "devices",
		icon: "list"
	}
}, _r = [], Q = [];
function vr(e) {
	_r.push(...e);
}
function yr(e) {
	let t = Q.findIndex((t) => t.id === e.id);
	t >= 0 ? Q[t] = e : Q.push(e);
}
function br(e = xr()) {
	let t = Q.filter((t) => e.moduleOn(t.id)).flatMap((e) => e.routes.map((t) => ({
		...t,
		ai: t.ai ?? e.ai
	})));
	return [..._r, ...t];
}
function xr() {
	let e;
	try {
		e = D().modules;
	} catch {
		e = void 0;
	}
	return {
		can: V,
		ai: Xe.value,
		moduleOn: (t) => e?.[t] !== !1,
		text: He
	};
}
function Sr(e, t = xr()) {
	return (!e.perm || t.can(e.perm)) && (!e.ai || t.ai);
}
var Cr = /* @__PURE__ */ new Set();
function wr(e) {
	Cr.has(e) || (Cr.add(e), console.warn(`menu: ${e}`));
}
function Tr(e) {
	return [..._r, ...Q.flatMap((e) => e.routes)].find((t) => t.path === e);
}
function Er(e, t) {
	let { label: n, route: r, icon: i, perm: a, ai: o } = e;
	if (e.module) {
		let s = Q.find((t) => t.id === e.module);
		if (!s) return wr(`module "${e.module}" is not part of this app`), null;
		if (!t.moduleOn(s.id)) return null;
		r ??= s.menu?.route ?? s.routes[0]?.path, n ??= s.menu?.label, i ??= s.menu?.icon, a ??= s.menu?.perm, o ??= s.ai;
	}
	if (!r || typeof r != "string") return wr(`item "${JSON.stringify(e.label)}" has no route or module`), null;
	let s = Tr(r);
	return !Sr({
		perm: a ?? s?.perm,
		ai: o ?? s?.ai
	}, t) || s && !Sr(s, t) ? null : {
		kind: "item",
		label: t.text(n) || r,
		href: r,
		icon: i
	};
}
function Dr(e, t) {
	e !== void 0 && !Array.isArray(e) && wr("config.json menu is not a list - using the default menu");
	let n = Array.isArray(e) ? e : Or(), r = [];
	for (let e of n) if (e && typeof e == "object") {
		if ("group" in e) {
			if (e.perm && !t.can(e.perm)) continue;
			let n = (Array.isArray(e.items) ? e.items : []).map((e) => Er(e, t)).filter((e) => !!e);
			n.length && r.push({
				kind: "group",
				label: t.text(e.group),
				items: n
			});
		} else {
			let n = Er(e, t);
			n && r.push(n);
		}
	}
	return r;
}
function Or() {
	let e = [], t = /* @__PURE__ */ new Map(), n = (n, r) => {
		if (!n) return void e.push(r);
		let i = JSON.stringify(n), a = t.get(i);
		a || (a = {
			group: n,
			items: []
		}, t.set(i, a), e.push(a)), a.items.push(r);
	};
	for (let e of _r) e.menu && n(e.menu.group, {
		label: e.menu.label,
		route: e.path,
		icon: e.menu.icon
	});
	for (let e of Q) e.menu && n(e.menu.group, { module: e.id });
	return e;
}
var kr = a(() => {
	L.value, z.value;
	let e;
	try {
		e = D().menu;
	} catch {
		return [];
	}
	return Dr(e, xr());
}), Ar = () => kr.value;
function jr(e, t) {
	return e === "/" ? t === "/" : t === e || t.startsWith(e.endsWith("/") ? e : e + "/");
}
//#endregion
//#region src/app/start.tsx
var Mr = [gr, cr];
function Nr(e, t = document.getElementById("app")) {
	document.documentElement.lang = L.value;
	for (let e of Mr) yr(e);
	return qt(), E().then((n) => {
		ke(n.languages), qt(n.theme), C(e(), t);
	}, (e) => {
		t.textContent = R("config_error", e.message);
	});
}
//#endregion
//#region src/nav/Routes.tsx
function Pr({ r: e, params: n }) {
	if (!Sr(e)) return /* @__PURE__ */ t(Y, {
		icon: "alert",
		title: R("not_allowed_title"),
		text: R("not_allowed_text")
	});
	let r = e.component;
	return /* @__PURE__ */ t(r, { params: n });
}
function Fr() {
	return /* @__PURE__ */ n(x, { children: [br().map((e) => /* @__PURE__ */ t(b, {
		path: e.path,
		children: (n) => /* @__PURE__ */ t(Pr, {
			r: e,
			params: n
		})
	}, e.path)), /* @__PURE__ */ t(b, { children: /* @__PURE__ */ t(Y, {
		title: R("not_found_title"),
		text: R("not_found_text")
	}) })] });
}
//#endregion
//#region src/frames/contract.tsx
var Ir = /* @__PURE__ */ new Map();
function Lr(e, t, n = {}) {
	Ir.set(e, {
		component: t,
		info: n
	});
}
var Rr = () => [...Ir.keys()], zr = (e) => Ir.get(e), Br = a(() => kr.value.flatMap((e) => e.kind === "group" ? e.items.map((t) => ({
	...t,
	group: e.label
})) : [{
	...e,
	group: ""
}]));
function Vr() {
	let [e, t] = S(), n = Br.value.filter((t) => jr(t.href, e)).sort((e, t) => t.href.length - e.href.length)[0];
	return {
		path: e,
		title: n?.label || "",
		group: n?.group || "",
		navigate: (e) => t(e)
	};
}
function Hr() {
	let e = "";
	try {
		e = D().tenant_name;
	} catch {}
	return {
		user: {
			name: Ze.value,
			email: B.value?.email || "",
			kind: z.value?.kind || ""
		},
		tenant: {
			slug: z.value?.tenant || "",
			name: z.value?.name || e
		},
		can: V,
		signOut: () => se()
	};
}
var Ur = o(null), Wr = !1;
async function Gr() {
	if (!V("alarms:read")) return void (Ur.value = null);
	try {
		let e = await ve.alarms({
			state: "open",
			limit: 100
		});
		Ur.value = {
			open: e.items.length,
			more: !!e.next_before
		};
	} catch {}
}
function Kr() {
	s(() => {
		if (Wr) return;
		Wr = !0, Gr();
		let e = setInterval(Gr, 6e4), t = () => document.visibilityState === "visible" && Gr();
		return document.addEventListener("visibilitychange", t), () => {
			Wr = !1, clearInterval(e), document.removeEventListener("visibilitychange", t);
		};
	}, []);
	let e = Ur.value;
	return {
		open: e?.open ?? 0,
		more: e?.more ?? !1,
		critical: 0,
		href: "/alarms",
		allowed: e !== null
	};
}
function qr() {
	return {
		mode: Ft.value,
		choice: Pt.value || "auto",
		setMode: (e) => Jt(e),
		logo: It.value.logo
	};
}
function $() {
	return {
		t: R,
		lang: L.value,
		languages: I.value,
		languageName: Me,
		setLang: (e) => ut(e)
	};
}
//#endregion
//#region src/frames/Sidebar.tsx
var Jr = (e) => e.split(/[\s@._-]+/).filter(Boolean).slice(0, 2).map((e) => e[0].toUpperCase()).join("") || "?";
function Yr() {
	return typeof document < "u" && document.title || "";
}
function Xr({ n: e, more: n }) {
	let { t: r } = $();
	return /* @__PURE__ */ t("span", {
		class: "text-[11.5px] font-semibold text-warn bg-warn-soft rounded-md px-1.5 py-px tabular-nums",
		"aria-label": r("alarms_open", n ? `${e}+` : e),
		children: n ? `${e}+` : e
	});
}
function Zr({ i: e, at: r, onGo: i }) {
	let a = jr(e.href, r), o = Kr();
	return /* @__PURE__ */ n(y, {
		href: e.href,
		onClick: i,
		"aria-current": a ? "page" : void 0,
		class: `flex items-center gap-2.5 h-[34px] px-2.5 rounded-[9px] no-underline ${a ? "bg-surface shadow-surface text-ink font-medium" : "text-ink-2 hover:bg-surface-2"}`,
		children: [
			e.icon ? /* @__PURE__ */ t(K, {
				n: e.icon,
				class: "size-[17px] shrink-0"
			}) : /* @__PURE__ */ t("span", { class: "size-[17px] shrink-0" }),
			/* @__PURE__ */ t("span", {
				class: "grow truncate",
				children: e.label
			}),
			e.href === o.href && o.open > 0 && /* @__PURE__ */ t(Xr, {
				n: o.open,
				more: o.more
			})
		]
	});
}
function Qr({ open: e, onClose: r }) {
	let i = l(null), { t: a } = $(), { navigate: o } = Vr(), [c, d] = u(""), [f, p] = u(0), m = Ar().flatMap((e) => e.kind === "group" ? e.items.map((t) => ({
		...t,
		group: e.label
	})) : [{
		...e,
		group: ""
	}]).filter((e) => `${e.group} ${e.label}`.toLowerCase().includes(c.trim().toLowerCase()));
	s(() => {
		let t = i.current;
		t && (e && !t.open ? (d(""), p(0), t.showModal()) : !e && t.open && t.close());
	}, [e]);
	let h = (e) => {
		r(), o(e);
	};
	return /* @__PURE__ */ n("dialog", {
		ref: i,
		onClose: r,
		"aria-label": a("search_pages"),
		"data-testid": "command-bar",
		class: "m-auto mt-[12vh] w-[min(560px,calc(100vw-32px))] rounded-surface bg-surface text-ink shadow-surface p-0 backdrop:bg-black/30",
		children: [/* @__PURE__ */ n("div", {
			class: "flex items-center gap-2 px-4 border-b border-line-soft",
			children: [/* @__PURE__ */ t(K, {
				n: "search",
				class: "size-4 text-muted"
			}), /* @__PURE__ */ t("input", {
				class: "grow h-12 bg-transparent outline-none text-[15px] placeholder:text-muted",
				placeholder: a("search_pages"),
				value: c,
				autoFocus: !0,
				role: "combobox",
				"aria-expanded": "true",
				"aria-controls": "gs-cmd-list",
				"aria-activedescendant": m[f] ? `gs-cmd-${f}` : void 0,
				onInput: (e) => {
					d(e.target.value), p(0);
				},
				onKeyDown: (e) => {
					e.key === "ArrowDown" && (e.preventDefault(), p((e) => Math.min(e + 1, m.length - 1))), e.key === "ArrowUp" && (e.preventDefault(), p((e) => Math.max(e - 1, 0))), e.key === "Enter" && m[f] && (e.preventDefault(), h(m[f].href));
				}
			})]
		}), /* @__PURE__ */ n("ul", {
			id: "gs-cmd-list",
			role: "listbox",
			class: "max-h-[50vh] overflow-y-auto p-2",
			children: [m.map((e, r) => /* @__PURE__ */ n("li", {
				id: `gs-cmd-${r}`,
				role: "option",
				"aria-selected": r === f,
				class: `flex items-center gap-2.5 h-9 px-2.5 rounded-control cursor-pointer text-sm ${r === f ? "bg-surface-2" : ""}`,
				onMouseEnter: () => p(r),
				onClick: () => h(e.href),
				children: [
					e.icon ? /* @__PURE__ */ t(K, {
						n: e.icon,
						class: "size-4 text-muted"
					}) : /* @__PURE__ */ t("span", { class: "size-4" }),
					/* @__PURE__ */ t("span", {
						class: "grow",
						children: e.label
					}),
					e.group && /* @__PURE__ */ t("span", {
						class: "text-xs text-muted",
						children: e.group
					})
				]
			}, e.href)), !m.length && /* @__PURE__ */ t("li", {
				class: "px-2.5 py-3 text-sm text-muted",
				children: a("search_none")
			})]
		})]
	});
}
function $r() {
	let { user: e, signOut: r } = Hr(), { t: i, lang: a, languages: o, languageName: c, setLang: u } = $(), { choice: d, setMode: f } = qr(), p = l(null);
	return s(() => {
		let e = (e) => p.current?.open && !p.current.contains(e.target) && (p.current.open = !1);
		return document.addEventListener("click", e), () => document.removeEventListener("click", e);
	}, []), /* @__PURE__ */ n("details", {
		ref: p,
		class: "relative",
		"data-testid": "user-menu",
		children: [/* @__PURE__ */ n("summary", {
			class: "flex items-center gap-2.5 px-2.5 py-2 rounded-[9px] cursor-pointer list-none hover:bg-surface-2 [&::-webkit-details-marker]:hidden",
			"aria-label": i("account"),
			children: [
				/* @__PURE__ */ t("span", {
					class: "size-[26px] rounded-full bg-surface-2 border border-line flex items-center justify-center text-[11px] font-semibold shrink-0",
					children: Jr(e.name)
				}),
				/* @__PURE__ */ t("span", {
					class: "grow truncate",
					children: e.name
				}),
				/* @__PURE__ */ t(K, {
					n: "updown",
					class: "size-4 text-muted"
				})
			]
		}), /* @__PURE__ */ n("div", {
			class: "absolute bottom-full left-0 right-0 mb-1 bg-surface rounded-control shadow-surface p-2 space-y-2 text-sm z-10",
			children: [
				e.email && /* @__PURE__ */ t("div", {
					class: "px-1 text-xs text-muted truncate",
					children: e.email
				}),
				/* @__PURE__ */ n("label", {
					class: "flex items-center gap-2 px-1",
					children: [
						/* @__PURE__ */ t(K, {
							n: "globe",
							class: "size-4 text-muted"
						}),
						/* @__PURE__ */ t("span", {
							class: "sr-only",
							children: i("language")
						}),
						/* @__PURE__ */ t("select", {
							class: "field py-1",
							"data-testid": "frame-lang",
							value: a,
							onChange: (e) => u(e.target.value),
							children: o.map((e) => /* @__PURE__ */ t("option", {
								value: e,
								children: c(e)
							}, e))
						})
					]
				}),
				/* @__PURE__ */ n("label", {
					class: "flex items-center gap-2 px-1",
					children: [
						/* @__PURE__ */ t(K, {
							n: "sun",
							class: "size-4 text-muted"
						}),
						/* @__PURE__ */ t("span", {
							class: "sr-only",
							children: i("scheme")
						}),
						/* @__PURE__ */ t("select", {
							class: "field py-1",
							value: d,
							onChange: (e) => f(e.target.value),
							children: [
								"auto",
								"light",
								"dark"
							].map((e) => /* @__PURE__ */ t("option", {
								value: e,
								children: i("scheme_" + e)
							}, e))
						})
					]
				}),
				/* @__PURE__ */ n("button", {
					class: "btn w-full justify-start",
					onClick: r,
					children: [/* @__PURE__ */ t(K, { n: "logout" }), i("sign_out")]
				})
			]
		})]
	});
}
function ei({ onGo: e, onSearch: r }) {
	let i = Ar(), { tenant: a } = Hr(), { logo: o } = qr(), { t: s } = $(), { path: c } = Vr(), l = Yr();
	return /* @__PURE__ */ n("div", {
		class: "flex flex-col gap-0.5 h-full text-[13.5px]",
		children: [
			/* @__PURE__ */ n("div", {
				class: "flex items-center gap-2.5 p-2 mb-2.5",
				children: [o ? /* @__PURE__ */ t("img", {
					src: o,
					alt: "",
					class: "size-7 rounded-lg object-contain"
				}) : /* @__PURE__ */ t("span", {
					class: "size-7 rounded-lg bg-primary text-primary-ink flex items-center justify-center font-semibold text-[13px]",
					"aria-hidden": "true",
					children: Jr(l || a.name)
				}), /* @__PURE__ */ n("span", {
					class: "flex flex-col leading-tight min-w-0",
					children: [/* @__PURE__ */ t("span", {
						class: "font-semibold truncate",
						children: l
					}), /* @__PURE__ */ t("span", {
						class: "text-xs text-muted truncate",
						"data-testid": "frame-tenant",
						children: a.name
					})]
				})]
			}),
			/* @__PURE__ */ n("button", {
				type: "button",
				onClick: r,
				"data-testid": "frame-search",
				class: "flex items-center gap-2 h-[34px] px-2.5 mb-3.5 border border-line bg-surface-2 rounded-[9px] text-[13px] text-muted",
				children: [
					/* @__PURE__ */ t(K, {
						n: "search",
						class: "size-[15px]"
					}),
					/* @__PURE__ */ t("span", {
						class: "grow text-left",
						children: s("search")
					}),
					/* @__PURE__ */ t("kbd", {
						class: "font-mono text-[11px] border border-line rounded-[5px] px-1.5 bg-surface",
						children: "⌘K"
					})
				]
			}),
			/* @__PURE__ */ t("nav", {
				"aria-label": s("menu_main"),
				"data-testid": "menu",
				class: "flex flex-col gap-0.5 overflow-y-auto grow",
				children: i.map((r) => r.kind === "item" ? /* @__PURE__ */ t(Zr, {
					i: r,
					at: c,
					onGo: e
				}, r.href) : /* @__PURE__ */ n("div", {
					role: "group",
					"aria-labelledby": `gs-grp-${r.label}`,
					class: "flex flex-col gap-0.5",
					children: [/* @__PURE__ */ t("span", {
						id: `gs-grp-${r.label}`,
						class: "text-[11.5px] font-medium text-muted px-2.5 pt-3 pb-1.5",
						children: r.label
					}), r.items.map((n) => /* @__PURE__ */ t(Zr, {
						i: n,
						at: c,
						onGo: e
					}, n.href))]
				}, r.label))
			}),
			/* @__PURE__ */ t($r, {})
		]
	});
}
function ti() {
	let e = Kr(), { t: r } = $();
	return !e.allowed || e.open === 0 ? null : /* @__PURE__ */ n(y, {
		href: e.href,
		"data-testid": "alarm-indicator",
		class: "flex items-center gap-1.5 h-7 px-2.5 rounded-full bg-warn-soft text-warn text-xs font-semibold no-underline",
		children: [/* @__PURE__ */ t(K, {
			n: "bell",
			class: "size-3.5"
		}), r("alarms_open", e.more ? `${e.open}+` : e.open)]
	});
}
function ni({ children: r }) {
	let [i, a] = u(!1), [o, c] = u(!1), { title: l, group: d } = Vr(), { t: f } = $();
	return s(() => {
		let e = (e) => {
			(e.metaKey || e.ctrlKey) && e.key.toLowerCase() === "k" && (e.preventDefault(), c(!0)), e.key === "Escape" && a(!1);
		};
		return window.addEventListener("keydown", e), () => window.removeEventListener("keydown", e);
	}, []), /* @__PURE__ */ n("div", {
		class: "min-h-dvh bg-canvas text-ink lg:flex lg:gap-2.5 lg:p-2.5",
		"data-frame": "sidebar",
		children: [
			/* @__PURE__ */ t("a", {
				href: "#gs-content",
				class: "sr-only focus:not-sr-only focus:absolute focus:top-2 focus:left-2 focus:z-50 btn",
				children: f("skip_to_content")
			}),
			/* @__PURE__ */ t("aside", {
				class: "hidden lg:block w-[236px] shrink-0 sticky top-2.5 h-[calc(100dvh-20px)] px-1.5 py-2",
				children: /* @__PURE__ */ t(ei, { onSearch: () => c(!0) })
			}),
			/* @__PURE__ */ n("div", {
				class: "lg:hidden flex items-center gap-2 h-14 px-3",
				children: [
					/* @__PURE__ */ t("button", {
						class: "btn btn-sm size-9 p-0",
						"aria-label": f("menu_open"),
						"aria-expanded": i,
						"data-testid": "menu-button",
						onClick: () => a(!0),
						children: /* @__PURE__ */ t(K, { n: "menu" })
					}),
					/* @__PURE__ */ t("span", {
						class: "font-semibold grow truncate",
						children: l || Yr()
					}),
					/* @__PURE__ */ t(ti, {})
				]
			}),
			i && /* @__PURE__ */ t("div", {
				class: "lg:hidden fixed inset-0 z-40 bg-black/30",
				onClick: (e) => e.target === e.currentTarget && a(!1),
				children: /* @__PURE__ */ n("aside", {
					class: "h-full w-[280px] max-w-[85vw] bg-canvas px-1.5 py-2 shadow-surface flex flex-col",
					"data-testid": "drawer",
					children: [/* @__PURE__ */ t("button", {
						class: "btn btn-sm size-9 p-0 self-end mr-1",
						"aria-label": f("menu_close"),
						onClick: () => a(!1),
						children: /* @__PURE__ */ t(K, { n: "x" })
					}), /* @__PURE__ */ t("div", {
						class: "grow min-h-0",
						children: /* @__PURE__ */ t(ei, {
							onGo: () => a(!1),
							onSearch: () => {
								a(!1), c(!0);
							}
						})
					})]
				})
			}),
			/* @__PURE__ */ n("main", {
				id: "gs-content",
				tabIndex: -1,
				class: "grow min-w-0 bg-surface lg:rounded-surface shadow-surface flex flex-col outline-none min-h-[calc(100dvh-56px)] lg:min-h-0",
				children: [/* @__PURE__ */ n("header", {
					class: "hidden lg:flex items-center gap-3 px-7 pt-[18px] text-[13px]",
					children: [/* @__PURE__ */ n("nav", {
						"aria-label": "breadcrumb",
						class: "flex items-center gap-2 grow min-w-0",
						children: [d && /* @__PURE__ */ n(e, { children: [/* @__PURE__ */ t("span", {
							class: "text-muted",
							children: d
						}), /* @__PURE__ */ t("span", {
							class: "text-line",
							"aria-hidden": "true",
							children: "/"
						})] }), /* @__PURE__ */ t("span", {
							class: "font-medium truncate",
							children: l
						})]
					}), /* @__PURE__ */ t(ti, {})]
				}), /* @__PURE__ */ t("div", {
					class: "grow px-4 pb-6 lg:px-7",
					children: r
				})]
			}),
			/* @__PURE__ */ t(Qr, {
				open: o,
				onClose: () => c(!1)
			})
		]
	});
}
//#endregion
//#region src/frames/Frame.tsx
var ri = { sidebar: ni }, ii = "";
function ai({ children: e }) {
	let n = "sidebar";
	try {
		n = D().frame || "sidebar";
	} catch {}
	let r = zr(n)?.component ?? ri[n];
	return !r && ii !== n && (ii = n, console.warn(`frame "${n}" is not registered - using sidebar`)), /* @__PURE__ */ t(r ?? ni, { children: e });
}
var oi = () => Object.keys(ri);
//#endregion
export { ar as ApiCallsPage, qn as ApiKeysPage, Fr as AppRoutes, sn as AuthGate, ur as BATTERY, rn as ChartBox, q as Chip, Ot as CursorPager, Fn as DebugPanel, hr as DeviceList, yt as Dialog, Ln as EXPIRY_WARN_DAYS, Y as Empty, vt as ErrorBox, G as F, ai as Frame, j as HttpError, K as Icon, J as Loading, xt as PAGE_SIZES, _t as PageHead, Et as Pager, Ce as SHELL_LANGS, te as ShellPlaceholder, ni as SidebarFrame, an as SignedOut, kt as THEME_COLORS, Ie as addStrings, Xe as aiOn, br as allRoutes, fn as anyTypeHas, F as api, cr as apiAccessModule, zn as apiDocsUrl, bt as apiErrors, Vn as apiKeyCreator, qt as applyTheme, tn as bandsPlugin, re as bearer, ct as browserDefaults, V as can, Ye as canEverywhere, pn as catalogueKey, ut as chooseLanguage, jn as clearTypes, Qt as color, xn as commandsOf, oe as completeSignIn, D as config, dr as contactTone, ie as currentUser, A as devMode, ue as deviceLabel, de as deviceSerial, gr as devicesModule, Ze as displayName, yn as enumValue, Hn as expiryFor, dn as firstRole, Re as fmt, Rr as frameIds, Ve as has, Qe as hasAnyRole, me as idOrder, jr as isActive, le as isUUID, ln as keyFor, Z as keyRoles, Bn as keyState, He as label, hn as labelFor, L as lang, Ue as langName, lt as langOf, Me as languageName, I as languages, H as liveState, E as loadConfig, We as loadSession, kn as loadType, On as loadTypes, ot as localeFor, B as me, kr as menu, $e as openStream, ve as opsApi, Ee as pickLang, Ht as presetFor, oi as presetIds, Ge as refreshMe, Lr as registerFrame, yr as registerModule, jt as registerPreset, vr as registerRoutes, Dr as resolveMenu, un as roleFor, Sr as routeAllowed, Ft as scheme, Pt as schemeChoice, ht as scopeText, ne as setConfig, je as setLang, ke as setLanguages, Jt as setScheme, w as shellVersion, ae as signIn, se as signOut, Nr as startApp, bn as stateKeys, mt as stateVal, R as t, It as theme, Vt as themeVars, en as timeAxis, pe as toDeviceID, Nn as typeCount, An as typeDetail, Sn as types, vn as unitFor, _n as unitPrint, Kr as useAlarmsBadge, Dt as useCursorPages, $ as useI18n, Mn as useKeyFor, tt as useLiveDevice, nt as useLiveDevices, Ar as useMenu, wt as usePageState, Tt as usePaged, Vr as useRoute, Hr as useSession, qr as useTheme, st as userLocale, U as userTZ, z as who, nn as withGaps };

//# sourceMappingURL=index.js.map